<template>
   <v-layout align-start>
      <v-flex
         xs12
         :style="
            $vuetify.breakpoint.xlOnly
               ? 'padding-right: 10%; padding-left: 10%'
               : ''
         "
      >
         <!-- MODAL: CUOTAS DUPLICADAS -->
         <v-dialog v-model="dialogCuotasDuplicadas" max-width="600" persistent>
            <v-card>
               <v-card-title class="error white--text py-4">
                  <v-icon color="white" left size="28">fa-exclamation-triangle</v-icon>
                  <span class="font-weight-bold" style="font-size:18px">
                     Atención: Su talonario requiere revisión
                  </span>
               </v-card-title>
               <v-card-text class="pt-6 pb-2">
                  <p style="font-size:16px" class="grey--text text--darken-3">
                     Estimado/a estudiante, hemos detectado que su talonario posee cuotas duplicadas. Esto puede afectar
                     el correcto procesamiento de sus pagos.
                  </p>
                  <p style="font-size:15px" class="grey--text text--darken-2 mt-3">
                     Le solicitamos respetuosamente comunicarse con soporte técnico al
                     siguiente correo electrónico, indicando su número de carnet y
                     adjuntando una captura de pantalla de este mensaje:
                  </p>
                  <v-alert
                     color="primary"
                     dark
                     class="mt-3 mb-2 text-center"
                     style="font-size:17px; letter-spacing:0.5px"
                  >
                     <v-icon left>fa-envelope</v-icon>
                     <strong style="word-break: break-all">consultas.tecnicaspagos.cri@catolica.edu.sv</strong>
                  </v-alert>
                  <v-divider class="my-3"></v-divider>
                  <p class="text-center grey--text text--darken-1 mb-1" style="font-size:14px">
                     Su número de carnet (incluirlo en el correo):
                  </p>
                  <p class="text-center font-weight-bold primary--text mb-0" style="font-size:22px; letter-spacing:2px">
                     {{ carnet }}
                  </p>
               </v-card-text>
            </v-card>
         </v-dialog>

         <!-- MODAL: CUOTAS SIN NPE -->
         <v-dialog v-model="dialogNpeFaltante" max-width="600" persistent>
            <v-card>
               <v-card-title class="error white--text py-4">
                  <v-icon color="white" left size="28">fa-exclamation-triangle</v-icon>
                  <span class="font-weight-bold" style="font-size:18px">
                     Atención: Su talonario requiere revisión
                  </span>
               </v-card-title>
               <v-card-text class="pt-6 pb-2">
                  <p style="font-size:16px" class="grey--text text--darken-3">
                     Estimado/a estudiante, hemos detectado que su talonario contiene
                     una o más cuotas sin número de NPE asignado. Esto puede impedir
                     que realice sus pagos correctamente.
                  </p>
                  <p style="font-size:15px" class="grey--text text--darken-2 mt-3">
                     Le solicitamos respetuosamente comunicarse con soporte técnico al
                     siguiente correo electrónico, indicando su número de carnet y
                     adjuntando una captura de pantalla de este mensaje:
                  </p>
                  <v-alert
                     color="primary"
                     dark
                     class="mt-3 mb-2 text-center"
                     style="font-size:17px; letter-spacing:0.5px"
                  >
                     <v-icon left>fa-envelope</v-icon>
                     <strong style="word-break: break-all">consultas.tecnicaspagos.cri@catolica.edu.sv</strong>
                  </v-alert>
                  <v-divider class="my-3"></v-divider>
                  <p class="text-center grey--text text--darken-1 mb-1" style="font-size:14px">
                     Su número de carnet (incluirlo en el correo):
                  </p>
                  <p class="text-center font-weight-bold primary--text mb-0" style="font-size:22px; letter-spacing:2px">
                     {{ carnet }}
                  </p>
               </v-card-text>
            </v-card>
         </v-dialog>

         <v-snackbar
            v-model="snackbar"
            :color="snackColor"
            :right="true"
            :bottom="true"
            :timeout="5000"
         >
            {{ snackText }}
            <template #action="{ attrs }">
               <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
               >
                  Cerrar
               </v-btn>
            </template>
         </v-snackbar>

         <!-- PARAMETROS SERFINSA -->
         <v-text-field
            id="TokenSerfinsa"
            v-model="tokenSerfinsa"
            style="display: none"
            readonly
            disabled
         ></v-text-field>
         <v-text-field
            id="IdTransaccion"
            v-model="idTransaccion"
            style="display: none"
            readonly
            disabled
         ></v-text-field>
         <v-text-field
            id="MontroTransaccion"
            v-model="totalPagar"
            style="display: none"
            readonly
            disabled
         ></v-text-field>
         <!-- Serfinsa btPagar trigger -->
         <v-btn id="btPagar" href="#" style="display: none"></v-btn>

         <!-- DIALOG CARNET ACTUALIZADO -->
         <v-dialog
            v-model="dialogCarnetGenerado"
            eager
            persistent
            max-width="600px"
         >
            <v-card>
               <v-card-text class="text--primary">
                  <v-container grid-list-md>
                     <v-layout wrap>
                        <v-flex xs12>
                           <v-flex xs12 class="text-h5 font-weight-medium">
                              Registro completado
                           </v-flex>
                           <v-flex
                              xs12
                              class="font-weight-medium text-justify py-8"
                              :style="
                                 $vuetify.breakpoint.smAndUp
                                    ? 'font-size: 16px;'
                                    : 'font-size: 15px;'
                              "
                           >
                              <span>
                                 Tu registro en el módulo de idiomas se ha
                                 realizado correctamente. Dirigete a la sección
                                 de
                                 <span class="colorPrimary"
                                    >pagos de idiomas</span
                                 >
                                 para realizar tu pago.
                              </span>
                           </v-flex>
                        </v-flex>
                     </v-layout>
                  </v-container>
               </v-card-text>
               <v-card-actions style="margin-top: -20px; padding-bottom: 20px">
                  <v-layout>
                     <v-spacer></v-spacer>
                     <v-btn
                        color="primary text--white"
                        width="150"
                        @click="closeCarnetGenerado"
                        >Entendido
                     </v-btn>
                     <v-spacer></v-spacer>
                  </v-layout>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <!-- DIALOG LOADING ESPERA RESPUESTA POPUP -->
         <v-dialog v-model="dialogEsperaPago" persistent width="333">
            <v-card :color="dialogEsperaColor" dark class="pt-5 pb-2">
               <v-card-text style="color: white" class="text-justify">
                  <strong>{{ dialogEsperaMessage }}</strong>
                  <br /><br />
                  {{ dialogEsperaSubMessage }}

                  <div
                     v-if="
                        dialogEsperaMessage ==
                        'Esperando respuesta de ventana de pago.'
                     "
                     class="text-center"
                  >
                     <a
                        style="
                           color: white;
                           font-weight: bold;
                           font-size: 17px;
                           text-decoration: underline;
                        "
                        @click="refreshPage"
                     >
                        <br />
                        Cancelar transacción
                        <br /><br />
                     </a>
                  </div>

                  <v-progress-linear
                     indeterminate
                     color="white"
                     class="mb-0"
                  ></v-progress-linear>
               </v-card-text>
            </v-card>
         </v-dialog>

         <!-- DIALOG REINICIAR NIVEL IDIOMAS -->
         <v-dialog v-model="dialogReiniciar" persistent width="350">
            <v-card class="py-6">
               <v-card-title
                  class="text-h6 py-4 text-justify"
                  style="word-break: normal"
               >
                  Esta por reiniciar el progreso de su módulo de idiomas al
                  nivel 1. ¿Desea continuar?
               </v-card-title>
               <v-card-actions class="d-flex justify-end">
                  <v-btn
                     class="mr-2"
                     outlined
                     color="primary"
                     @click="dialogReiniciar = false"
                     >Cancelar</v-btn
                  >
                  <v-btn color="primary" dark @click="reiniciarNivel"
                     >Si, reiniciar</v-btn
                  >
               </v-card-actions>
            </v-card>
         </v-dialog>

         <!-- DIALOG INFORMACION DE BECA -->
         <BecarioForm
            v-model="dialogBecaInfo"
            :carnet="carnet"
            :periodo-lectivo="cicloBeca"
            @enviado="infoBecaActualizada($event)"
         />

         <!-- DIALOG SUBIR COMPROBANTE DE BECA -->
         <ComprobanteBecario
            v-model="dialogBecaComp"
            :carnet="carnet"
            :periodos-lectivos="ciclosBecasPendientes"
         />

         <!-- DIALOG SOLICITAR DUI -->
         <DuiForm
            v-model="dialogDuiInfo"
            :carnet="carnet"
            @enviado="infoDuiActualizado($event)"
         />

         <!-- DIALOG REGISTRO MODULO IDIOMAS -->
         <RegistroIdiomas
            ref="RegistroIdiomas"
            v-model="dialogRegistroIdiomas"
            :carnet="carnet"
            :nombres="nombres"
            :apellidos="apellidos"
            @carnet-generado="showCarnetGenerado($event)"
         />

         <!-- DIALOG DETALLE DE PAGO DE CUOTA-->
         <v-dialog v-model="dialogPagoCuota" eager persistent max-width="600px">
            <v-form>
               <v-card>
                  <v-card-text class="text--primary" style="margin-top: -20px">
                     <v-container grid-list-md>
                        <v-layout wrap>
                           <v-flex xs12>
                              <v-flex xs12 class="text-h5 font-weight-medium">
                                 Detalles pago de cuota # {{ numeroCuota }} -
                                 {{ periodoLectivo }}
                              </v-flex>
                              <v-card class="borderDetallesPrimary mt-2">
                                 <v-container>
                                    <v-layout wrap>
                                       <v-flex xs12>
                                          <v-data-table
                                             hide-default-footer
                                             :items-per-page="-1"
                                             :footer-props="{
                                                itemsPerPageOptions: [-1],
                                                itemsPerPageText:
                                                   'Filas por página:'
                                             }"
                                             :headers="headersAranceles"
                                             :items="filteredCuotaArancel"
                                          >
                                             <template
                                                #item.descripcion="{ item }"
                                             >
                                                {{
                                                   item.descripcion.replace(
                                                      '_',
                                                      ' '
                                                   )
                                                }}
                                             </template>
                                             <template
                                                #item.precioUnitario="{ item }"
                                             >
                                                $
                                                {{
                                                   numFormatIntl(
                                                      Number(
                                                         item.precioUnitario
                                                      ) +
                                                         Number(
                                                            item.montoImpuesto
                                                         )
                                                   )
                                                }}
                                             </template>
                                          </v-data-table>
                                       </v-flex>
                                    </v-layout>
                                 </v-container>
                              </v-card>
                              <v-flex v-if="cuotaTipoBeca != null" mt-2 xs12>
                                 <v-card style="border-radius: 15px">
                                    <v-card-text
                                       class="text--primary"
                                       :style="
                                          $vuetify.breakpoint.smAndUp
                                             ? 'font-size: 16px;'
                                             : 'font-size: 15px;'
                                       "
                                    >
                                       <v-layout wrap fill-height align-center>
                                          <v-flex xs12 sm1 text-center>
                                             <v-icon size="35" color="primary"
                                                >fa-info-circle</v-icon
                                             >
                                          </v-flex>
                                          <v-flex xs12 sm11 text-justify>
                                             <p
                                                class="font-weight-medium"
                                                style="margin-bottom: 10px"
                                             >
                                                <strong>
                                                   Reglamento de Becas de la
                                                   Universidad:
                                                </strong>
                                             </p>
                                             <p
                                                class="font-weight-medium"
                                                style="margin-bottom: 10px"
                                             >
                                                <strong>Art. 2.</strong>- "Se
                                                entiende por beca la exención
                                                económica que podrá cubrir
                                                parcial o totalmente la
                                                matrícula y las cuotas por ciclo
                                                académico."
                                             </p>
                                             <p
                                                class="font-weight-medium"
                                                style="margin-bottom: 0px"
                                             >
                                                <strong>Art. 9.</strong>- "La
                                                beca ordinariamente se concederá
                                                a partir del pago de la segunda
                                                cuota, en cada ciclo académico.
                                                Otros aranceles propios de la
                                                Universidad, no incluidos en la
                                                beca, serán cancelados por el
                                                becario."
                                             </p>
                                          </v-flex>
                                       </v-layout>
                                    </v-card-text>
                                 </v-card>
                              </v-flex>
                              <v-flex
                                 v-if="cuotaTipoBeca != null"
                                 xs12
                                 class="font-weight-medium text-h6 text-center mt-1 colorPrimary"
                              >
                                 <span style="color: black"
                                    >Cuota completa: $
                                    {{ totalSinDescuento }}
                                 </span>
                                 <br />
                                 {{ cuotaTipoBeca.toUpperCase() }}
                                 <br />
                                 Descuento: {{ cuotaDescuento }}%
                                 <br />
                                 Total a pagar: $
                                 {{ totalPagar }}
                              </v-flex>
                              <v-flex
                                 v-if="cuotaTipoBeca == null"
                                 xs12
                                 class="font-weight-medium text-h6 text-center mt-1"
                              >
                                 Total a pagar: $ {{ totalPagar }}
                              </v-flex>
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </v-card-text>
                  <v-card-actions
                     style="margin-top: -20px; padding-bottom: 20px"
                  >
                     <v-layout>
                        <v-spacer></v-spacer>
                        <v-btn
                           color="gray"
                           text
                           class="mr-1"
                           width="150"
                           @click.native="closePagoCuota"
                           >Cancelar</v-btn
                        >
                        <v-btn
                           href="#"
                           color="primary text--white"
                           class="ml-1"
                           width="150"
                           :disabled="pagosDeshabilitados"
                           @click="pagosDeshabilitados ? false : initPago()"
                           >Pagar
                        </v-btn>
                        <v-spacer></v-spacer>
                     </v-layout>
                  </v-card-actions>
               </v-card>
            </v-form>
         </v-dialog>

         <!-- DIALOG DETALLE DE PAGO DE CUOTA MULTIPLE -->
         <v-dialog
            v-model="dialogPagoCuotaMultiple"
            eager
            persistent
            max-width="600px"
         >
            <v-form>
               <v-card>
                  <v-card-text class="text--primary" style="margin-top: -20px">
                     <v-container grid-list-md>
                        <v-layout wrap>
                           <v-flex xs12>
                              <v-flex xs12 class="text-h5 font-weight-medium">
                                 Opción de pago multiple
                              </v-flex>
                              <v-flex xs12 class="text-h6">
                                 Detalles de pago
                              </v-flex>
                              <v-card class="borderDetallesPrimary mt-2">
                                 <v-container>
                                    <v-layout wrap>
                                       <v-flex xs12>
                                          <v-data-table
                                             hide-default-footer
                                             :items-per-page="-1"
                                             :footer-props="{
                                                itemsPerPageOptions: [-1],
                                                itemsPerPageText:
                                                   'Filas por página:'
                                             }"
                                             :headers="headersAranceles"
                                             :items="cuotasPagoMultiple"
                                          >
                                             <template
                                                #item.precioUnitario="{ item }"
                                             >
                                                $
                                                {{
                                                   numFormatIntl(
                                                      Number(
                                                         item.precioUnitario
                                                      )
                                                   )
                                                }}
                                             </template>
                                          </v-data-table>
                                       </v-flex>
                                    </v-layout>
                                 </v-container>
                              </v-card>
                              <v-flex
                                 xs12
                                 class="font-weight-medium text-h6 text-center mt-1"
                              >
                                 Total a pagar: $
                                 {{ numFormatIntl(totalPagar) }}
                              </v-flex>
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </v-card-text>
                  <v-card-actions
                     style="margin-top: -20px; padding-bottom: 20px"
                  >
                     <v-layout>
                        <v-spacer></v-spacer>
                        <v-btn
                           color="gray"
                           text
                           class="mr-1"
                           width="150"
                           @click.native="closePagoCuotaMultiple"
                           >Cancelar</v-btn
                        >
                        <v-btn
                        
                           href="#"
                           color="primary text--white"
                           class="ml-1"
                           width="150"
                           :disabled="pagosDeshabilitados"
                           @click="pagosDeshabilitados ? false : initPago()"
                           >Pagar
                        </v-btn>
                        <v-spacer></v-spacer>
                     </v-layout>
                  </v-card-actions>
               </v-card>
            </v-form>
         </v-dialog>

         <!-- DIALOG DETALLE DE PAGO DE ARANCEL-->
         <v-dialog
            v-model="dialogPagoArancel"
            eager
            persistent
            max-width="600px"
         >
            <v-form>
               <v-card>
                  <v-card-text class="text--primary" style="margin-top: -20px">
                     <v-container grid-list-md>
                        <v-layout wrap>
                           <v-flex xs12>
                              <v-flex xs12 class="text-h5 font-weight-medium">
                                 Detalles pago de arancel
                              </v-flex>
                              <v-card class="borderDetallesPrimary mt-2">
                                 <v-container>
                                    <v-layout wrap>
                                       <v-flex xs12>
                                          <v-data-table
                                             hide-default-footer
                                             :items-per-page="-1"
                                             :footer-props="{
                                                itemsPerPageOptions: [-1],
                                                itemsPerPageText:
                                                   'Filas por página:'
                                             }"
                                             :headers="headersAranceles"
                                             :items="detallePagoArancel"
                                          >
                                          </v-data-table>
                                       </v-flex>
                                    </v-layout>
                                 </v-container>
                              </v-card>
                              <v-flex xs12 mt-4>
                                 <p
                                    class="text-subtitle-1 font-weight-medium text-justify"
                                 >
                                    <span class="colorPrimary"
                                       >Descripción:
                                    </span>
                                    <span style="white-space: pre-line">
                                       {{
                                          arancelDescripcion.replace(
                                             /\\n/g,
                                             '\n'
                                          )
                                       }}
                                    </span>
                                 </p>
                              </v-flex>
                              <v-flex
                                 v-if="arancelCantidad"
                                 xs12
                                 mt-4
                                 :style="
                                    $vuetify.breakpoint.smAndUp
                                       ? 'margin: 0% 25%;'
                                       : ''
                                 "
                              >
                                 <v-input-number
                                    :value="itemCantidad"
                                    label="Cantidad"
                                    :min="1"
                                    :max="maxEquivalencias"
                                    @input="itemCantidad = $event"
                                 ></v-input-number>
                              </v-flex>
                              <v-flex
                                 xs12
                                 class="font-weight-medium text-h6 text-center mt-1"
                              >
                                 Total a pagar: $ {{ totalPagar }}
                              </v-flex>
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </v-card-text>
                  <v-card-actions
                     style="margin-top: -20px; padding-bottom: 20px"
                  >
                     <v-layout>
                        <v-spacer></v-spacer>
                        <v-btn
                           color="gray"
                           text
                           class="mr-1"
                           width="150"
                           @click.native="closePagoArancel"
                           >Cancelar</v-btn
                        >
                        <v-btn
                           href="#"
                           color="primary text--white"
                           class="ml-1"
                           width="150"
                           :disabled="pagosDeshabilitados"
                           @click="pagosDeshabilitados ? false : initPago()"
                           >Pagar
                        </v-btn>
                        <v-spacer></v-spacer>
                     </v-layout>
                  </v-card-actions>
               </v-card>
            </v-form>
         </v-dialog>

         <!-- DIALOG DETALLE DE PAGO DE IDIOMAS -->
         <v-dialog
            v-model="dialogPagoIdioma"
            eager
            persistent
            max-width="600px"
         >
            <v-form
               ref="formPagoIdioma"
               v-model="validPagoIdioma"
               lazy-validation
            >
               <v-card>
                  <v-card-text class="text--primary" style="margin-top: -20px">
                     <v-container grid-list-md>
                        <v-layout wrap>
                           <v-flex xs12>
                              <v-flex xs12 class="text-h5 font-weight-medium">
                                 Detalles pago de idiomas
                              </v-flex>
                              <v-card class="borderDetallesPrimary mt-2">
                                 <v-container>
                                    <v-layout wrap>
                                       <v-flex xs12 mt-4>
                                          <p
                                             class="text-subtitle-1 font-weight-medium text-justify"
                                          >
                                             <span class="colorPrimary"
                                                >Idioma:
                                             </span>
                                             <span>
                                                {{ idiomaNombre }}
                                             </span>
                                             <br />
                                             <span class="colorPrimary"
                                                >Nivel:
                                             </span>
                                             <span>
                                                {{ intToRoman(idiomaNivel) }}
                                             </span>
                                             <br />
                                             <span class="colorPrimary"
                                                >Programa:
                                             </span>
                                             <span>
                                                {{ idiomaProgramaDesc }}
                                             </span>

                                             <v-flex
                                                v-if="recargoIdiomas > 0"
                                                class="pl-0"
                                             >
                                                <span class="colorPrimary"
                                                   >Recargo por pago
                                                   extemporáneo:
                                                </span>
                                                <span>
                                                   ${{ recargoIdiomas }}
                                                </span>
                                             </v-flex>
                                          </p>
                                       </v-flex>
                                    </v-layout>
                                 </v-container>
                              </v-card>
                              <v-flex v-if="idiomaVencido" xs12 class="mt-4">
                                 <v-layout
                                    wrap
                                    fill-height
                                    align-center
                                    :class="
                                       $vuetify.breakpoint.smAndUp
                                          ? 'px-6'
                                          : 'px-4 py-4'
                                    "
                                 >
                                    <v-flex
                                       xs12
                                       :class="
                                          $vuetify.breakpoint.smAndUp
                                             ? 'text-center'
                                             : 'text-center'
                                       "
                                    >
                                       <v-icon size="35" color="primary">
                                          fa-info-circle
                                       </v-icon>
                                    </v-flex>
                                    <v-flex
                                       xs12
                                       text-justify
                                       :class="
                                          $vuetify.breakpoint.smAndUp
                                             ? 'pt-2 pl-4'
                                             : 'pt-2'
                                       "
                                    >
                                       <p
                                          class="font-weight-medium colorPrimary"
                                          style="
                                             margin-bottom: 5px;
                                             font-size: 18px;
                                             line-height: 1.6;
                                          "
                                       >
                                          Estimado alumno/a. Ya han transcurrido
                                          {{ idiomaMesesDesdeUltimoModulo }}
                                          meses desde la finalización de su
                                          último módulo de idiomas, actualmente
                                          el limite de inactividad permitido es
                                          de
                                          {{ idiomaLimiteMesesInacividad }}
                                          meses. <br /><br />
                                          En esta situación puede optar por
                                          realizar exámen de ubicación el cual
                                          puede cancelar en la sección de pagos
                                          de aranceles ó reiniciar su progreso
                                          al nivel 1 haciendo clic en el
                                          siguiente botón.
                                       </p>
                                    </v-flex>
                                    <v-flex xs12 class="d-flex justify-center">
                                       <v-btn
                                          color="primary"
                                          @click="dialogReiniciar = true"
                                          >Reiniciar nivel</v-btn
                                       >
                                    </v-flex>
                                 </v-layout>
                              </v-flex>
                              <v-flex
                                 v-if="nivelDeshabilitado"
                                 xs12
                                 class="mt-4"
                              >
                                 <v-layout
                                    wrap
                                    fill-height
                                    align-center
                                    :class="
                                       $vuetify.breakpoint.smAndUp
                                          ? 'px-6'
                                          : 'px-4 py-4'
                                    "
                                 >
                                    <v-flex
                                       xs12
                                       sm1
                                       :class="
                                          $vuetify.breakpoint.smAndUp
                                             ? 'text-left'
                                             : 'text-center'
                                       "
                                    >
                                       <v-icon size="35" color="primary">
                                          fa-info-circle
                                       </v-icon>
                                    </v-flex>
                                    <v-flex
                                       xs12
                                       sm11
                                       text-justify
                                       :class="
                                          $vuetify.breakpoint.smAndUp
                                             ? 'pt-2 pl-4'
                                             : 'pt-2'
                                       "
                                    >
                                       <p
                                          class="font-weight-medium colorPrimary"
                                          style="
                                             margin-bottom: 5px;
                                             font-size: 18px;
                                             line-height: 1.6;
                                          "
                                       >
                                          El nivel que desea cursar no se
                                          impartirá en esta entrega para el
                                          programa que ha seleccionado, por
                                          favor intente con otro programa.
                                       </p>
                                    </v-flex>
                                 </v-layout>
                              </v-flex>
                              <v-flex v-if="cupoAgotado" xs12 class="mt-4">
                                 <v-layout
                                    wrap
                                    fill-height
                                    align-center
                                    :class="
                                       $vuetify.breakpoint.smAndUp
                                          ? 'px-6'
                                          : 'px-4 py-4'
                                    "
                                 >
                                    <v-flex
                                       xs12
                                       sm1
                                       :class="
                                          $vuetify.breakpoint.smAndUp
                                             ? 'text-left'
                                             : 'text-center'
                                       "
                                    >
                                       <v-icon size="35" color="primary">
                                          fa-info-circle
                                       </v-icon>
                                    </v-flex>
                                    <v-flex
                                       xs12
                                       sm11
                                       text-justify
                                       :class="
                                          $vuetify.breakpoint.smAndUp
                                             ? 'pt-2 pl-4'
                                             : 'pt-2'
                                       "
                                    >
                                       <p
                                          class="font-weight-medium colorPrimary"
                                          style="
                                             margin-bottom: 5px;
                                             font-size: 18px;
                                             line-height: 1.6;
                                          "
                                       >
                                          Estimado alumno/a, el cupo para el
                                          nivel 1 del programa que usted ha
                                          seleccionado se encuentra agotado en
                                          estos momentos.
                                       </p>
                                    </v-flex>
                                 </v-layout>
                              </v-flex>
                              <v-flex xs12 mt-4>
                                 <p class="text-h6 font-weight-medium">
                                    Seleccione el programa en el que desea
                                    continuar:
                                 </p>
                                 <v-autocomplete
                                    v-model="selectPrograma"
                                    :items="cmbProgramas"
                                    :rules="rulesPrograma"
                                    :disabled="idiomaVencido"
                                    color="primary"
                                    item-text="nombre"
                                    item-value="programaId"
                                    label="Programas activos disponibles"
                                 >
                                 </v-autocomplete>
                              </v-flex>
                              <v-flex
                                 xs12
                                 class="font-weight-medium text-h6 text-center mt-1"
                              >
                                 Total a pagar: $
                                 {{
                                    totalPagar === ''
                                       ? '0.00'
                                       : numFormatIntl(totalPagar)
                                 }}
                              </v-flex>
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </v-card-text>
                  <v-card-actions
                     style="margin-top: -20px; padding-bottom: 20px"
                  >
                     <v-layout>
                        <v-spacer></v-spacer>
                        <v-btn
                           color="gray"
                           text
                           class="mr-1"
                           width="150"
                           @click.native="closePagoIdioma"
                           >Cancelar</v-btn
                        >
                        <v-btn
                           href="#"
                           color="primary text--white"
                           class="ml-1"
                           width="150"
                           :disabled="
                              pagosIdiomasDeshabilitados ||
                              disablePagoIdioma ||
                              !validPagoIdioma ||
                              idiomaVencido
                           "
                           @click="
                              pagosIdiomasDeshabilitados ||
                              nivelDeshabilitado ||
                              idiomaVencido
                                 ? false
                                 : validatePagoIdiomas()
                           "
                           >Pagar
                        </v-btn>
                        <v-spacer></v-spacer>
                     </v-layout>
                  </v-card-actions>
               </v-card>
            </v-form>
         </v-dialog>

         <!-- SI ESTA VERIFICADO -->
         <v-card v-if="mostrarMensaje" class="borderDetallesPrimary mx-8">
            <v-layout
               wrap
               fill-height
               align-center
               :class="$vuetify.breakpoint.smAndUp ? 'px-6' : 'px-4 py-4'"
            >
               <v-flex xs12 sm1 text-center>
                  <v-icon size="35" color="primary"> fa-info-circle </v-icon>
               </v-flex>
               <v-flex xs12 sm11 text-justify class="pt-2">
                  <span class="font-weight-bold colorPrimary">
                     AVISO IMPORTANTE:
                  </span>
                  <p class="font-weight-medium" style="margin-bottom: 10px">
                     {{ mensajeImportante }}
                  </p>
               </v-flex>
            </v-layout>
         </v-card>
         <!-- TEMPORIZADOR DE SESION ALUMNO -->
         <v-layout v-if="verificado" justify-center class="my-2">
            <v-chip
               :color="sessionCountdownSeconds <= 30 ? 'error' : sessionCountdownSeconds <= 60 ? 'warning' : 'success'"
               dark
               label
               class="font-weight-bold"
            >
               <v-icon left>fa-clock</v-icon>
               Tiempo de sesión: {{ tiempoRestanteFormato }}
            </v-chip>
         </v-layout>

         <v-stepper
            v-if="verificado"
            v-model="stepNum"
            non-linear
            class="elevation-0"
         >
            <v-stepper-header v-if="false"> </v-stepper-header>

            <v-stepper-items>
               <!-- PANTALLA DE BIENVENIDA -->
               <v-stepper-content step="1">
                  <v-layout wrap text-center>
                     <v-flex xs12>
                        <v-img
                           src="/assets/logo-u700.png"
                           class="my-3"
                           contain
                           height="260"
                        ></v-img>
                     </v-flex>

                     <v-flex xs12 mb-4>
                        <h1 class="text-h3 font-weight-bold mb-3">
                           UNICAES <br />
                           Colecturía Digital
                           <div v-if="sede == 'IL'">ILOBASCO</div>
                        </h1>
                     </v-flex>
                     <v-flex xs12 mb-4>
                        <span class="font-weight-bold text-h5 mb-3">
                           {{ alumnoMessage }}
                        </span>
                        <span
                           class="colorPrimary font-weight-bold text-h5 mb-3"
                        >
                           {{ alumno }}
                        </span>
                     </v-flex>
                     <v-flex xs12>
                        <span class="font-weight-bold text-h5 mb-3">
                           ¿Que tipo de pago deseas realizar?
                        </span>
                     </v-flex>
                     <v-flex xs12 class="mt-4">
                        <v-btn
                           color="primary"
                           x-large
                           width="250"
                           :class="$vuetify.breakpoint.smAndUp ? 'mr-1' : ''"
                           @click="listarCuotas"
                        >
                           Pagos de cuotas
                        </v-btn>
                        <v-btn
                           color="primary"
                           x-large
                           width="250"
                           :class="
                              $vuetify.breakpoint.smAndUp ? 'ml-1' : 'mt-2'
                           "
                           @click="irPagoAranceles"
                        >
                           Pagos de aranceles
                        </v-btn>
                     </v-flex>
                     <v-flex
                        xs12
                        :class="
                           $vuetify.breakpoint.smAndUp
                              ? 'mt-2 mb-8'
                              : 'mt-0 mb-8'
                        "
                     >
                        <v-btn
                           color="primary"
                           :loading="loadingPagosIdiomas"
                           :disabled="loadingPagosIdiomas"
                           x-large
                           width="250"
                           :class="
                              $vuetify.breakpoint.smAndUp ? 'mr-1' : 'mt-2'
                           "
                           @click="irPagoIdiomas"
                        >
                           <template #loader>
                              <span>Cargando...</span>
                           </template>
                           Pagos de idiomas
                        </v-btn>
                        <v-btn
                           color="primary"
                           outlined
                           x-large
                           width="250"
                           :class="
                              $vuetify.breakpoint.smAndUp ? 'ml-1' : 'mt-2'
                           "
                           @click="listarPagos"
                        >
                           Historial de pagos
                        </v-btn>
                     </v-flex>
                     <v-flex xs12>
                        <p class="text-h6 font-weight-bold">
                           Versión: {{ version }}
                        </p>
                     </v-flex>
                  </v-layout>
               </v-stepper-content>

               <!-- PAGOS DE CUOTAS DE TALONARIOS -->
               <v-stepper-content
                  step="2"
                  :style="
                     $vuetify.breakpoint.xsOnly
                        ? 'margin: 0px 0px; padding: 0px 0px;'
                        : ''
                  "
               >
                  <v-container fluid grid-list-lg class="white pt-0 mt-1">
                     <v-layout wrap>
                        <v-flex xs12>
                           <v-toolbar flat color="white">
                              <v-toolbar-title class="text-h5 font-weight-bold"
                                 >Pagos de cuotas</v-toolbar-title
                              >
                              <v-spacer></v-spacer>
                           </v-toolbar>
                        </v-flex>
                        <v-flex v-if="pagosDeshabilitados" xs12 ml-4>
                           <p class="colorPrimary font-weight-bold text-h6">
                              Sistema en mantenimiento, se han desactivado las
                              funciones de pago en línea.
                              <v-icon
                                 color="primary"
                                 style="margin-top: -5px"
                                 right
                                 size="30"
                              >
                                 fas fa-info-circle
                              </v-icon>
                           </p>
                           <p class="grey--text text--darken-1" style="font-size: 14px">
                              <strong>Modo mantenimiento activado:</strong> {{ mantenimientoDesde }}
                           </p>
                           <p class="grey--text text--darken-1" style="font-size: 14px">
                              <strong>Hora actual:</strong> {{ horaActual }}
                           </p>
                        </v-flex>
                        <v-flex xs12>
                           <!-- INFORMACION ALUMNO -->
                           <v-layout wrap class="pl-4 pr-4">
                              <v-flex xs12 sm2 class="smallForm">
                                 <v-text-field
                                    v-model="carnet"
                                    color="primary"
                                    label="Carnet"
                                    readonly
                                 ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm5 class="smallForm">
                                 <v-text-field
                                    v-model="alumno"
                                    label="Alumno"
                                    color="primary"
                                    readonly
                                 ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm5 class="smallForm">
                                 <v-autocomplete
                                    v-if="false"
                                    v-model="selectCarrera"
                                    :items="cmbCarrera"
                                    color="primary"
                                    item-text="nombre"
                                    item-value="codigo"
                                    label="Carrera"
                                    placeholder="Seleccionar..."
                                    readonly
                                 >
                                 </v-autocomplete>
                                 <v-text-field
                                    v-model="carreraNombre"
                                    label="Carrera"
                                    color="primary"
                                    readonly
                                 ></v-text-field>
                              </v-flex>
                           </v-layout>
                        </v-flex>
                        <v-flex v-if="poseeBecaActiva" xs12>
                           <v-card class="borderDetallesSecondary">
                              <v-card-text
                                 class="text--primary font-weight-medium"
                                 :style="
                                    $vuetify.breakpoint.smAndUp
                                       ? 'font-size: 18px;'
                                       : 'font-size: 15px;'
                                 "
                              >
                                 <v-layout wrap fill-height align-center>
                                    <v-flex xs12 sm1 text-center>
                                       <v-icon size="35" color="orange darken-4"
                                          >fa-info-circle</v-icon
                                       >
                                    </v-flex>
                                    <v-flex xs12 sm11 text-justify>
                                       <p
                                          class="font-weight-bold"
                                          style="margin-bottom: 10px"
                                       >
                                          Estimado alumno/a:
                                       </p>
                                       <p
                                          class="font-weight-medium"
                                          style="margin-bottom: 10px"
                                       >
                                          Después de hacer un pago de cuotas que
                                          apliquen a un descuento de becas, debe
                                          dirigirse al
                                          <a href="#" @click="listarPagos"
                                             >Historial de pagos</a
                                          >
                                          para descargar su comprobante de beca.
                                          El cual, deberá descargarlo,
                                          imprimirlo, firmarlo, escanearlo y
                                          subirlo a esta aplicación. De no hacer
                                          esto, su proceso estará incompleto y
                                          no podrá realizar el pago de las
                                          siguientes cuotas.
                                       </p>
                                    </v-flex>
                                 </v-layout>
                              </v-card-text>
                           </v-card>
                        </v-flex>
                        <v-flex xs12>
                           <v-card class="borderDetallesPrimary">
                              <v-card-text class="text--primary">
                                 <v-layout wrap mb-2>
                                    <v-flex xs12 sm6>
                                       <span class="text-h6">
                                          Estado de cuenta
                                       </span>
                                    </v-flex>
                                    <v-flex xs12 sm6 text-right>

                                       <v-btn
                                          v-if="cuotasSeleccionadas.length > 1"
                                          color="primary"
                                          :disabled="
                                             pagosDeshabilitados ||
                                             debeComprobantes
                                          "
                                          @click="
                                             pagosDeshabilitados ||
                                             debeComprobantes
                                                ? false
                                                : showPagoCuotaMultiple()
                                          "
                                       >
                                          Pagar cuotas seleccionadas
                                       </v-btn>
                                    </v-flex>
                                 </v-layout>
                                 <v-layout wrap>
                                    <!-- DATATABLE DETALLES DE CUOTAS PENDIENTES -->
                                    <v-flex xs12 sm12 style="margin-top: -20px">
                                       <v-skeleton-loader
                                          v-if="loadingCuotas"
                                          type="table-row-divider@4"
                                          class="mx-auto"
                                       ></v-skeleton-loader>
                                       <v-data-table
                                          v-show="!loadingCuotas"
                                          v-model="cuotasSeleccionadas"
                                          :headers="headersCuotas"
                                          :loading="loadingCuotas"
                                          loading-text="Listando cuotas... Por favor espere."
                                          :items="detallesPendientes"
                                          hide-default-footer
                                          disable-sort
                                          :items-per-page="-1"
                                          :footer-props="{
                                             itemsPerPageOptions: [-1],
                                             itemsPerPageText:
                                                'Filas por página:'
                                          }"
                                          item-key="npe"
                                          hidden-actions
                                          show-select
                                       >
                                          <template #header.data-table-select>
                                          </template>
                                          <template
                                             #item.data-table-select="{
                                                item,
                                                isSelected,
                                                select
                                             }"
                                          >
                                             <v-simple-checkbox
                                                v-if="!item.facturado"
                                                :value="isSelected"
                                                :disabled="item.facturado"
                                                @input="
                                                   select(
                                                      checkCondition(
                                                         $event,
                                                         item,
                                                         isSelected
                                                      )
                                                   )
                                                "
                                             ></v-simple-checkbox>
                                             <v-tooltip
                                                v-else
                                                top
                                                max-width="300"
                                                color="primary"
                                             >
                                                <template #activator="{ on }">
                                                   <v-icon
                                                      color="primary"
                                                      v-on="on"
                                                      >fa-check</v-icon
                                                   >
                                                </template>
                                                <span style="font-size: 15px">
                                                   Cuota cancelada
                                                </span>
                                             </v-tooltip>
                                          </template>

                                          <template #item.npe="{ item }">
                                             <div
                                                v-if="
                                                   $vuetify.breakpoint.smAndUp
                                                "
                                             >
                                                {{
                                                   disabledCuota(item, true)
                                                      ? '************************************'
                                                      : item.npe
                                                }}
                                             </div>
                                             <div
                                                v-if="
                                                   $vuetify.breakpoint.xsOnly
                                                "
                                                style="width: 150px"
                                             >
                                                <v-text-field
                                                   color="primary"
                                                   readonly
                                                   :value="
                                                      disabledCuota(item, true)
                                                         ? '************************************'
                                                         : item.npe
                                                   "
                                                >
                                                   <v-icon
                                                      v-if="
                                                         $vuetify.breakpoint
                                                            .xsOnly
                                                      "
                                                      slot="prepend"
                                                      color="primary"
                                                      :disabled="
                                                         disabledCuota(
                                                            item,
                                                            true
                                                         )
                                                      "
                                                      @click="
                                                         copyToClip(
                                                            disabledCuota(
                                                               item,
                                                               true
                                                            )
                                                               ? '************************************'
                                                               : item.npe
                                                         )
                                                      "
                                                      >far fa-copy</v-icon
                                                   >
                                                </v-text-field>
                                             </div>
                                          </template>
                                          <template #item.opciones="{ item }">
                                             <v-tooltip bottom color="primary">
                                                <template #activator="{ on }">
                                                   <v-btn
                                                      text
                                                      small
                                                      fab
                                                      color="primary"
                                                      :disabled="
                                                         disabledCuota(item) ||
                                                         item.facturado
                                                      "
                                                      v-on="on"
                                                      @click="
                                                         disabledCuota(item) ||
                                                         item.facturado
                                                            ? false
                                                            : showPagoCuota(
                                                                 item
                                                              )
                                                      "
                                                   >
                                                      <v-icon>
                                                         far fa-credit-card
                                                      </v-icon>
                                                   </v-btn>
                                                </template>
                                                <span>Pagar</span>
                                             </v-tooltip>
                                             <v-tooltip
                                                bottom
                                                max-width="300"
                                                color="primary"
                                                :disabled="!item.facturado"
                                             >
                                                <template
                                                   #activator="{ on, attrs }"
                                                >
                                                   <v-btn
                                                      text
                                                      small
                                                      fab
                                                      v-bind="attrs"
                                                      :color="
                                                         item.facturado
                                                            ? 'grey darken-1'
                                                            : 'orange'
                                                      "
                                                      :disabled="
                                                         disabledCuota(
                                                            item,
                                                            true
                                                         )
                                                      "
                                                      v-on="on"
                                                      @click="
                                                         disabledCuota(
                                                            item,
                                                            true
                                                         ) || item.facturado
                                                            ? listarPagos()
                                                            : imprimirCuota(
                                                                 item
                                                              )
                                                      "
                                                   >
                                                      <v-icon
                                                         >fas fa-print</v-icon
                                                      >
                                                   </v-btn>
                                                </template>
                                                <span>
                                                   Si canceló en línea y desea
                                                   volver imprimir un
                                                   comprobante dirijase a la
                                                   pantalla de historial de
                                                   pagos.
                                                </span>
                                             </v-tooltip>
                                          </template>
                                          <template #item.monto="{ item }">
                                             <span
                                                :class="
                                                   item.tipoBeca != null
                                                      ? 'colorPrimary'
                                                      : ''
                                                "
                                                style="white-space: pre-line"
                                             >
                                                {{
                                                   item.tipoBeca == null
                                                      ? '$' +
                                                        numFormatIntl(
                                                           Number(item.monto) +
                                                              Number(
                                                                 item.recargo
                                                              )
                                                        )
                                                      : `Beca ${item.descuentoPorBeca}%\n` +
                                                        '$' +
                                                        numFormatIntl(
                                                           Number(
                                                              item.montoConDescuento
                                                           ) +
                                                              Number(
                                                                 item.recargo
                                                              )
                                                        )
                                                }}
                                             </span>
                                          </template>

                                          <template #item.estado="{ item }">
                                             <v-chip
                                                :color="getColorEstado(item)"
                                                dark
                                             >
                                                <span>{{
                                                   item.facturado
                                                      ? 'Cancelado'
                                                      : getStatus(item)
                                                }}</span>
                                             </v-chip>
                                          </template>
                                          <template #no-data>
                                             <h3>
                                                No tienes cuotas pendientes
                                             </h3>
                                          </template>
                                       </v-data-table>
                                    </v-flex>
                                 </v-layout>
                              </v-card-text>
                           </v-card>
                        </v-flex>
                     </v-layout>
                     <v-btn class="mt-4" color="primary" @click="stepNum = 1">
                        Regresar
                     </v-btn>
                  </v-container>
               </v-stepper-content>

               <!-- PAGO DE ARANCELES -->
               <v-stepper-content
                  step="3"
                  :style="
                     $vuetify.breakpoint.xsOnly
                        ? 'margin: 0px 0px; padding: 0px 0px;'
                        : ''
                  "
               >
                  <v-container fluid grid-list-lg class="white pt-0 mt-1">
                     <v-layout wrap>
                        <v-flex xs12>
                           <v-toolbar flat color="white">
                              <v-toolbar-title class="text-h5 font-weight-bold"
                                 >Pagos de aranceles</v-toolbar-title
                              >
                              <v-spacer></v-spacer>
                           </v-toolbar>
                        </v-flex>
                        <v-flex v-if="pagosDeshabilitados" xs12 ml-4>
                           <p class="colorPrimary font-weight-bold text-h6">
                              Sistema en mantenimiento, se han desactivado las
                              funciones de pago en línea.
                              <v-icon
                                 color="primary"
                                 style="margin-top: -5px"
                                 right
                                 size="30"
                              >
                                 fas fa-info-circle
                              </v-icon>
                           </p>
                           <p class="grey--text text--darken-1" style="font-size: 14px">
                              <strong>Modo mantenimiento activado:</strong> {{ mantenimientoDesde }}
                           </p>
                           <p class="grey--text text--darken-1" style="font-size: 14px">
                              <strong>Hora actual:</strong> {{ horaActual }}
                           </p>
                        </v-flex>
                        <v-flex xs12>
                           <!-- INFORMACION ALUMNO -->
                           <v-layout wrap class="pl-4 pr-4">
                              <v-flex xs12 sm2 class="smallForm">
                                 <v-text-field
                                    v-model="carnet"
                                    color="primary"
                                    label="Carnet"
                                    readonly
                                 ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm5 class="smallForm">
                                 <v-text-field
                                    v-model="alumno"
                                    label="Alumno"
                                    color="primary"
                                    readonly
                                 ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm5 class="smallForm">
                                 <v-autocomplete
                                    v-if="false"
                                    v-model="selectCarrera"
                                    :items="cmbCarrera"
                                    color="primary"
                                    item-text="nombre"
                                    item-value="codigo"
                                    label="Carrera"
                                    placeholder="Seleccionar..."
                                    readonly
                                 >
                                 </v-autocomplete>
                                 <v-text-field
                                    v-model="carreraNombre"
                                    label="Carrera"
                                    color="primary"
                                    readonly
                                 ></v-text-field>
                              </v-flex>
                           </v-layout>
                        </v-flex>
                        <v-flex xs12>
                           <v-form
                              ref="formPagoProgramaArancel"
                              v-model="validPagoProgramaArancel"
                              lazy-validation
                           >
                              <v-card class="borderDetallesPrimary">
                                 <v-card-text class="text--primary">
                                    <v-layout wrap>
                                       <v-flex xs12 sm4>
                                          <span class="text-h6"
                                             >Aranceles disponibles</span
                                          >
                                       </v-flex>
                                       <v-spacer></v-spacer>
                                       <v-flex xs12 sm5>
                                          <v-autocomplete
                                             v-model="selectArancel"
                                             :loading="loadingAranceles"
                                             :items="cmbArancel"
                                             color="primary"
                                             item-text="nombre"
                                             item-value="codigo"
                                             label="Arancel"
                                             no-data-text="Sin resultados"
                                             placeholder="Seleccionar..."
                                          >
                                             <template #item="{ item }">
                                                <v-list-item-content>
                                                   <v-list-item-title
                                                      v-text="item.nombre"
                                                   ></v-list-item-title>
                                                   <v-list-item-subtitle
                                                      v-text="
                                                         'Monto ' + item.precio
                                                      "
                                                   ></v-list-item-subtitle>
                                                </v-list-item-content>
                                             </template>
                                          </v-autocomplete>
                                       </v-flex>
                                       <v-flex
                                          v-if="
                                             selectArancel == '03-021-3' ||
                                             selectArancel == '03-120-3'
                                          "
                                          xs3
                                       >
                                          <v-autocomplete
                                             v-model="selectProgramaArancel"
                                             :items="cmbProgramas"
                                             :rules="rulesPrograma"
                                             color="primary"
                                             item-text="nombre"
                                             item-value="programaId"
                                             label="Programa"
                                             no-data-text="Sin resultados"
                                             placeholder="Seleccionar..."
                                          >
                                          </v-autocomplete>
                                       </v-flex>
                                    </v-layout>
                                    <v-layout wrap>
                                       <!-- DATATABLE DETALLES DE ARANCELES -->
                                       <v-flex
                                          xs12
                                          sm12
                                          style="margin-top: -20px"
                                       >
                                          <v-data-table
                                             hide-default-footer
                                             :headers="headersAraFiltered"
                                             :items="detallesAranceles"
                                             :items-per-page="-1"
                                             :footer-props="{
                                                itemsPerPageOptions: [-1],
                                                itemsPerPageText:
                                                   'Filas por página:'
                                             }"
                                             :loading="loadingAranPagados"
                                             disable-sort
                                             hidden-actions
                                          >
                                             <template
                                                #item.opciones="{ item }"
                                             >
                                                <v-tooltip
                                                   bottom
                                                   color="primary"
                                                >
                                                   <template
                                                      #activator="{ on }"
                                                   >
                                                      <v-btn
                                                         text
                                                         small
                                                         fab
                                                         color="primary"
                                                         :disabled="
                                                            disabledArancel(
                                                               item
                                                            ) ||
                                                            loadingAranPagados ||
                                                            !validPagoProgramaArancel
                                                         "
                                                         v-on="on"
                                                         @click="
                                                            disabledArancel(
                                                               item
                                                            ) || item.facturado
                                                               ? false
                                                               : showPagoArancel(
                                                                    item
                                                                 )
                                                         "
                                                      >
                                                         <v-icon
                                                            >far
                                                            fa-credit-card</v-icon
                                                         >
                                                      </v-btn>
                                                   </template>
                                                   <span>Pagar</span>
                                                </v-tooltip>
                                                <v-btn
                                                   text
                                                   small
                                                   fab
                                                   color="orange"
                                                   @click="
                                                      disabledArancel(item) ||
                                                      item.facturado
                                                         ? imprimirArancel(item)
                                                         : imprimirArancel(item)
                                                   "
                                                >
                                                   <v-tooltip
                                                      top
                                                      max-width="300"
                                                      bottom
                                                      color="primary"
                                                   >
                                                      <template
                                                         #activator="{ on }"
                                                      >
                                                         <v-icon v-on="on"
                                                            >fas
                                                            fa-print</v-icon
                                                         >
                                                      </template>
                                                      <span
                                                         style="font-size: 15px"
                                                      >
                                                         Este documento solo
                                                         será aceptado en
                                                         ventanillas de
                                                         Colecturía, UNICAES.
                                                      </span>
                                                   </v-tooltip>
                                                </v-btn>
                                             </template>
                                             <template #no-data>
                                                <h3>Selecciona un arancel</h3>
                                             </template>
                                             <template #item.precio="{ item }">
                                                $
                                                {{
                                                   numFormatIntl(
                                                      Number(item.precio)
                                                   )
                                                }}
                                             </template>
                                          </v-data-table>
                                       </v-flex>
                                    </v-layout>
                                 </v-card-text>
                              </v-card>
                           </v-form>
                        </v-flex>
                     </v-layout>
                     <v-btn class="mt-4" color="primary" @click="stepNum = 1">
                        Regresar
                     </v-btn>
                  </v-container>
               </v-stepper-content>

               <!-- PAGO DE IDIOMAS -->
               <v-stepper-content
                  step="4"
                  :style="
                     $vuetify.breakpoint.xsOnly
                        ? 'margin: 0px 0px; padding: 0px 0px;'
                        : ''
                  "
               >
                  <v-container fluid grid-list-lg class="white pt-0 mt-1">
                     <v-layout wrap>
                        <v-flex xs12>
                           <v-toolbar flat color="white">
                              <v-toolbar-title class="text-h5 font-weight-bold"
                                 >Pagos de idiomas</v-toolbar-title
                              >
                              <v-spacer></v-spacer>
                           </v-toolbar>
                        </v-flex>
                        <v-flex v-if="pagosIdiomasDeshabilitados" xs12>
                           <v-card class="borderDetallesPrimary">
                              <v-card-text
                                 class="text--primary font-weight-medium"
                                 :style="
                                    $vuetify.breakpoint.smAndUp
                                       ? 'font-size: 18px;'
                                       : 'font-size: 15px;'
                                 "
                              >
                                 <v-layout wrap fill-height align-center>
                                    <v-flex xs12 sm1 text-center>
                                       <v-icon size="35" color="primary"
                                          >fa-info-circle</v-icon
                                       >
                                    </v-flex>
                                    <v-flex xs12 sm11 text-justify>
                                       <p
                                          class="font-weight-bold"
                                          style="margin-bottom: 10px"
                                       >
                                          Estimado alumno/a:
                                       </p>
                                       <p
                                          class="font-weight-medium"
                                          style="margin-bottom: 10px"
                                       >
                                          El periodo de inscripción para los
                                          módulos de idiomas ha finalizado.
                                       </p>
                                    </v-flex>
                                 </v-layout>
                              </v-card-text>
                           </v-card>
                        </v-flex>
                        <v-flex v-else xs12>
                           <v-layout wrap>
                              <v-flex xs12>
                                 <!-- INFORMACION ALUMNO -->
                                 <v-layout wrap class="pl-4 pr-4">
                                    <v-flex xs12 sm2 class="smallForm">
                                       <v-text-field
                                          v-model="carnet"
                                          color="primary"
                                          label="Carnet"
                                          readonly
                                       ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm5 class="smallForm">
                                       <v-text-field
                                          v-model="alumno"
                                          label="Alumno"
                                          color="primary"
                                          readonly
                                       ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm5 class="smallForm">
                                       <v-autocomplete
                                          v-if="false"
                                          v-model="selectCarrera"
                                          :items="cmbCarrera"
                                          color="primary"
                                          item-text="nombre"
                                          item-value="codigo"
                                          label="Carrera"
                                          placeholder="Seleccionar..."
                                          readonly
                                       >
                                       </v-autocomplete>
                                       <v-text-field
                                          v-model="carreraNombre"
                                          label="Carrera"
                                          color="primary"
                                          readonly
                                       ></v-text-field>
                                    </v-flex>
                                 </v-layout>
                              </v-flex>
                              <v-flex xs12>
                                 <v-card class="borderDetallesSecondary">
                                    <v-card-text class="text--primary">
                                       <v-layout wrap fill-height align-center>
                                          <v-flex xs12>
                                             <span class="text-h6">
                                                Último pago de idiomas
                                                registrado en Colecturía Digital
                                             </span>
                                          </v-flex>

                                          <v-flex xs12>
                                             <v-data-table
                                                :headers="headersPagosIdiomas"
                                                :items="ultimoPagoIdiomas"
                                                disable-sort
                                                hide-default-footer
                                                :items-per-page="10"
                                                hidden-actions
                                             >
                                                <template #item.historial="{}">
                                                   <v-btn
                                                      dark
                                                      color="orange darken-3"
                                                      @click="listarPagos"
                                                   >
                                                      Ver historial
                                                   </v-btn>
                                                </template>

                                                <template
                                                   #item.monto="{ item }"
                                                >
                                                   $
                                                   {{
                                                      numFormatIntl(item.monto)
                                                   }}
                                                </template>

                                                <template #no-data>
                                                   <h3>
                                                      No tienes pagos de idiomas
                                                      registrados
                                                   </h3>
                                                </template>
                                             </v-data-table>
                                          </v-flex>
                                       </v-layout>
                                    </v-card-text>
                                 </v-card>
                              </v-flex>
                              <v-flex xs12>
                                 <v-card class="borderDetallesPrimary">
                                    <v-card-text class="text--primary">
                                       <v-layout
                                          v-if="cmbModuloIdiomas.length > 0"
                                          wrap
                                       >
                                          <v-flex xs12>
                                             <span class="text-h6">
                                                Módulo de idiomas a pagar
                                             </span>
                                          </v-flex>
                                       </v-layout>
                                       <v-layout wrap>
                                          <v-flex
                                             xs12
                                             sm12
                                             style="margin-top: -20px"
                                          >
                                             <v-flex
                                                v-if="
                                                   cmbModuloIdiomas.length > 0
                                                "
                                             >
                                                <v-data-table
                                                   :headers="headersIdioma"
                                                   :items="cmbModuloIdiomas"
                                                   disable-sort
                                                   :items-per-page="10"
                                                   :footer-props="{
                                                      itemsPerPageOptions: [
                                                         10, 20, 30
                                                      ],
                                                      itemsPerPageText:
                                                         'Filas por página:'
                                                   }"
                                                   hidden-actions
                                                >
                                                   <template
                                                      #item.nivel="{ item }"
                                                   >
                                                      {{
                                                         intToRoman(
                                                            item.ultimoNivelAprobado
                                                         )
                                                      }}
                                                   </template>
                                                   <template
                                                      #item.monto="{ item }"
                                                   >
                                                      $
                                                      {{
                                                         numFormatIntl(
                                                            item.montoConRecargo
                                                         )
                                                      }}
                                                   </template>
                                                   <template
                                                      #item.idioma="{ item }"
                                                   >
                                                      {{
                                                         item.idioma == 'EN'
                                                            ? 'Inglés'
                                                            : item.idioma ==
                                                              'FR'
                                                            ? 'Francés'
                                                            : item.idioma
                                                      }}
                                                   </template>
                                                   <template
                                                      #item.opciones="{ item }"
                                                   >
                                                      <v-tooltip
                                                         bottom
                                                         color="primary"
                                                      >
                                                         <template
                                                            #activator="{ on }"
                                                         >
                                                            <v-btn
                                                               text
                                                               small
                                                               fab
                                                               color="primary"
                                                               v-on="on"
                                                               @click="
                                                                  showPagoIdioma(
                                                                     item
                                                                  )
                                                               "
                                                            >
                                                               <v-icon>
                                                                  far
                                                                  fa-credit-card
                                                               </v-icon>
                                                            </v-btn>
                                                         </template>
                                                         <span>Pagar</span>
                                                      </v-tooltip>
                                                   </template>
                                                   <template #no-data>
                                                      <h3>
                                                         No se encontraron
                                                         registros
                                                      </h3>
                                                   </template>
                                                </v-data-table>
                                             </v-flex>
                                             <v-flex v-else class="mt-4">
                                                <span
                                                   class="text-subtitle-1 font-weight-medium"
                                                >
                                                   No tienes pagos pendientes
                                                   asociados a tu número de
                                                   carnet. Si crees que ha
                                                   habido algún error ó no te
                                                   aparece el pago de tu módulo
                                                   de idiomas, escríbenos al
                                                   correo de
                                                   <a>{{ correoDev }}</a>

                                                   <br /><br />

                                                   Si aún no cursas ningún
                                                   módulo de idiomas y deseas
                                                   registrarte
                                                   <a>por primera vez</a>
                                                   en uno, puedes hacerlo
                                                   completando este
                                                   <v-chip
                                                      color="primary"
                                                      label
                                                      link
                                                      @click="
                                                         dialogRegistroIdiomas = true
                                                      "
                                                   >
                                                      Formulario de inscripción </v-chip
                                                   >. Después de registrarte
                                                   esta página se actualizará y
                                                   le aparecerá disponible el
                                                   pago para el
                                                   <a>nivel 1</a>
                                                   del módulo que haya
                                                   seleccionado.
                                                </span>
                                             </v-flex>
                                          </v-flex>
                                       </v-layout>
                                    </v-card-text>
                                 </v-card>
                              </v-flex>
                           </v-layout>
                        </v-flex>
                     </v-layout>
                     <v-btn class="mt-4" color="primary" @click="stepNum = 1">
                        Regresar
                     </v-btn>
                  </v-container>
               </v-stepper-content>

               <!-- HISTORIAL DE PAGOS -->
               <v-stepper-content
                  step="5"
                  :style="
                     $vuetify.breakpoint.xsOnly
                        ? 'margin: 0px 0px; padding: 0px 0px;'
                        : ''
                  "
               >
                  <v-container fluid grid-list-lg class="white pt-0 mt-1">
                     <v-layout wrap>
                        <v-flex xs12>
                           <v-toolbar flat color="white">
                              <v-toolbar-title class="text-h5 font-weight-bold">
                                 Historial de pagos
                              </v-toolbar-title>
                              <v-spacer></v-spacer>
                           </v-toolbar>
                        </v-flex>
                        <v-flex xs12>
                           <!-- INFORMACION ALUMNO -->
                           <v-layout wrap class="pl-4 pr-4">
                              <v-flex xs12 sm2 class="smallForm">
                                 <v-text-field
                                    v-model="carnet"
                                    color="primary"
                                    label="Carnet"
                                    readonly
                                 ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm5 class="smallForm">
                                 <v-text-field
                                    v-model="alumno"
                                    label="Alumno"
                                    color="primary"
                                    readonly
                                 ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm5 class="smallForm">
                                 <v-autocomplete
                                    v-if="false"
                                    v-model="selectCarrera"
                                    :items="cmbCarrera"
                                    color="primary"
                                    item-text="nombre"
                                    item-value="codigo"
                                    label="Carrera"
                                    placeholder="Seleccionar..."
                                    readonly
                                 >
                                 </v-autocomplete>
                                 <v-text-field
                                    v-model="carreraNombre"
                                    label="Carrera"
                                    color="primary"
                                    readonly
                                 ></v-text-field>
                              </v-flex>
                           </v-layout>
                        </v-flex>
                        <v-flex v-if="poseeBecaActiva" xs12>
                           <v-card class="borderDetallesSecondary">
                              <v-card-text
                                 class="text--primary font-weight-medium"
                                 :style="
                                    $vuetify.breakpoint.smAndUp
                                       ? 'font-size: 18px;'
                                       : 'font-size: 15px;'
                                 "
                              >
                                 <v-layout wrap fill-height align-center>
                                    <v-flex xs12 sm1 text-center>
                                       <v-icon size="35" color="orange darken-4"
                                          >fa-upload</v-icon
                                       >
                                    </v-flex>
                                    <v-flex xs12 sm11 text-justify>
                                       <v-layout wrap>
                                          <v-flex xs12 sm6 pt-4>
                                             Sube tus comprobantes de beca
                                             firmados aquí
                                          </v-flex>
                                          <v-flex xs12 sm6>
                                             <v-btn
                                                block
                                                color="grey lighten-2"
                                                @click="dialogBecaComp = true"
                                             >
                                                Subir comprobantes
                                             </v-btn>
                                          </v-flex>
                                       </v-layout>
                                    </v-flex>
                                 </v-layout>
                                 <v-divider class="my-4"></v-divider>
                                 <v-layout wrap fill-height align-center>
                                    <v-flex xs12 sm1 text-center>
                                       <v-icon size="35" color="orange darken-4"
                                          >fa-info-circle</v-icon
                                       >
                                    </v-flex>
                                    <v-flex xs12 sm8 text-justify>
                                       <p
                                          class="font-weight-bold"
                                          style="margin-bottom: 10px"
                                       >
                                          Estimado alumno/a:
                                       </p>
                                       <p
                                          class="font-weight-medium"
                                          style="margin-bottom: 10px"
                                       >
                                          De no subir firmados los comprobantes
                                          de beca de su último pago de cuotas,
                                          su proceso estará incompleto y no
                                          podrá realizar el pago de nuevas
                                          cuotas. <br /><br />

                                          <a href="#">IMPORTANTE:</a><br />
                                          Solo se aceptarán archivos PDF's que
                                          incluyan el documento de comprobante
                                          de beca, no debe incluir comprobantes
                                          de pago u otros documentos. Puede
                                          descargar dicho comprobante haciendo
                                          clic en el botón de COMP. BECA. Si
                                          usted posee una beca y no le aparece
                                          este botón por favor comunicarse al
                                          correo de:
                                          <br />
                                          <a :href="'mailto:' + correoDev">
                                             {{ correoDev }}
                                          </a>
                                       </p>
                                    </v-flex>
                                    <v-flex xs12 sm3 px-12 text-justify>
                                       <v-card outlined>
                                          <v-img
                                             src="/assets/ejemplo-comp-beca.jpg"
                                             contain
                                             height="100%"
                                             max-height="350"
                                             width="100%"
                                             @click="
                                                openImage(
                                                   'assets/ejemplo-comp-beca.jpg'
                                                )
                                             "
                                          ></v-img>
                                       </v-card>
                                    </v-flex>
                                 </v-layout>
                              </v-card-text>
                           </v-card>
                        </v-flex>
                        <v-flex xs12>
                           <v-card class="borderDetallesPrimary">
                              <v-card-text class="text--primary">
                                 <v-layout wrap>
                                    <v-flex xs12 sm6>
                                       <div
                                          class="text-h6"
                                          style="padding-top: 20px"
                                       >
                                          Pagos registrados por medio de
                                          Colecturía Digital
                                       </div>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                       <v-text-field
                                          v-model="searchPagos"
                                          color="primary"
                                          append-icon="fa-search"
                                          label="Busqueda"
                                       ></v-text-field>
                                    </v-flex>
                                 </v-layout>
                                 <v-layout wrap>
                                    <!-- DATATABLE DETALLES DE ARANCELES -->
                                    <v-flex xs12>
                                       <v-data-table
                                          :headers="headersPagos"
                                          :items="pagosRegistrados"
                                          :loading="loadingPagos"
                                          :search="searchPagos"
                                          loading-text="Listando pagos... Por favor espere."
                                          disable-sort
                                          :items-per-page="10"
                                          :footer-props="{
                                             itemsPerPageOptions: [10, 20, 30],
                                             itemsPerPageText:
                                                'Filas por página:'
                                          }"
                                          hidden-actions
                                       >
                                          <template #item.total="{ item }">
                                             $
                                             {{ item.total }}
                                          </template>
                                          <template #item.concepto="{ item }">
                                             {{ generarConcepto(item) }}
                                          </template>
                                          <template #item.compBeca="{ item }">
                                             <v-btn
                                                v-if="
                                                   item.detalle.some(
                                                      (obj) =>
                                                         obj.tipoBeca != null
                                                   )
                                                "
                                                dark
                                                block
                                                color="orange darken-3"
                                                @click="
                                                   generarComprobanteBeca(
                                                      'save',
                                                      item
                                                   )
                                                "
                                             >
                                                Comp. beca
                                             </v-btn>
                                             <v-btn
                                                v-else
                                                block
                                                text
                                                color="primary"
                                             >
                                                N/A
                                             </v-btn>
                                          </template>
                                          <template
                                             #item.comprobante="{ item }"
                                          >
                                             <v-btn
                                                dark
                                                color="orange darken-3"
                                                @click="
                                                   reImprimirComprobantePago(
                                                      item
                                                   )
                                                "
                                             >
                                                Comp. Pago
                                             </v-btn>
                                          </template>
                                          <template #no-data>
                                             <h3>
                                                No tienes pagos registrados
                                             </h3>
                                          </template>
                                       </v-data-table>
                                    </v-flex>
                                 </v-layout>
                              </v-card-text>
                           </v-card>
                        </v-flex>
                     </v-layout>
                     <v-btn class="mt-4" color="primary" @click="stepNum = 1">
                        Regresar
                     </v-btn>
                  </v-container>
               </v-stepper-content>
            </v-stepper-items>
         </v-stepper>

         <!-- SIN CUPO: LÍMITE DE PESTAÑAS ALCANZADO -->
         <EsperaSesiones v-if="sinCupo" :carnet="carnet" :cuenta-atras="cuentaSesion" />

         <!-- SI NO ESTA VERIFICADO -->
         <v-container v-if="!verificado && !sinCupo" fluid>
            <v-layout justify-center wrap>
               <v-flex
                  xs12
                  class="text-center mt-8"
                  :style="
                     $vuetify.breakpoint.smAndUp
                        ? 'padding-left: 10%; padding-right: 10%'
                        : ''
                  "
               >
                  <p class="font-weight-medium text-h3">
                     {{ loadingMessage }}
                  </p>
                  <p v-if="carnet" class="font-weight-bold text-h5 colorPrimary mt-2">
                     {{ carnet }}
                  </p>
                  <p v-if="loadingFechaHora" class="grey--text text--darken-1 mt-1" style="font-size: 15px">
                     {{ loadingFechaHora }}
                  </p>

                  <!-- CONTADOR DE CARGA -->
                  <div v-if="loadingContadorHandle !== null" class="mt-4">
                     <v-chip
                        color="primary"
                        dark
                        large
                        class="font-weight-bold"
                     >
                        <v-icon left>fa-spinner fa-spin</v-icon>
                        Espera {{ Math.max(0, 5 - loadingSegundos) }}s...
                     </v-chip>
                  </div>

                  <!-- MANTENIMIENTO EN PANTALLA DE CARGA -->
                  <v-flex v-if="pagosDeshabilitados" xs12 ml-4 class="mt-5">
                     <p class="colorPrimary font-weight-bold text-h6">
                        Sistema en mantenimiento, se han desactivado las
                        funciones de pago en línea.
                        <v-icon
                           color="primary"
                           style="margin-top: -5px"
                           right
                           size="30"
                        >
                           fas fa-info-circle
                        </v-icon>
                     </p>
                     <p class="grey--text text--darken-1" style="font-size: 14px">
                        <strong>Modo mantenimiento activado:</strong> {{ mantenimientoDesde }}
                     </p>
                   
                  </v-flex>
               </v-flex>
            </v-layout>
         </v-container>
      </v-flex>
   </v-layout>
</template>

<script>
import axios from 'axios'
import formatters from '../mixins/formattersLib'
import { Base64 } from 'js-base64'
import { mask } from 'vue-the-mask'
import { authComputed } from '../helpers'
import jQuery from 'jquery'
import InputNumber from '../components/custom/InputNumber'
import BecarioForm from '../components/BecarioForm'
import DuiForm from '../components/DuiForm'
import ComprobanteBecario from '../components/ComprobanteBecario'
import RegistroIdiomas from '../components/RegistroIdiomas'
import EsperaSesiones from '../components/EsperaSesiones'
const getReporteLib = () => import('../mixins/reporteLib')

// Definiendo variables
const $ = jQuery
window.$ = $
window.jQuery = $

export default {
   name: 'ColecturiaDigital',
   components: {
      'v-input-number': InputNumber,
      BecarioForm: BecarioForm,
      DuiForm: DuiForm,
      ComprobanteBecario: ComprobanteBecario,
      RegistroIdiomas: RegistroIdiomas,
      EsperaSesiones: EsperaSesiones
   },
   directives: {
      mask
   },
   mixins: [formatters],

   data: (vm) => ({

      //carrera Original
      codigoCarreraOriginal: null,
      // Imagenes
      logo64: null,
      cda64: null,
      selloCancelado: null,
      selloCanceladoNoDate: null,
      emptyImage: null,
      correoDev: process.env.VUE_APP_CORREO_DEV,
      dialogNpeFaltante: false,
      dialogCuotasDuplicadas: false,

      // Variables
      sede: process.env.VUE_APP_SEDE,
      version: process.env.VUE_APP_VERSION,
      mapState: window.mapState,
      pagosDeshabilitados: false,
      mantenimientoDesde: '',
      horaActual: '',
      horaActualHandle: null,
      configuracionCargada: false,
      cupoAgotado: false,
      pagosIdiomasDeshabilitados: false,
      mostrarMensaje: false,
      mensajeImportante: '',
      countBeca: 0,
      poseeBecaActiva: false,
      cicloActual: '',
      cicloBeca: '',
      EQUIVALENCIA_INTERNA: '01-045',
      EQUIVALENCIA_EXTERNA: '01-024',
      EXAMEN_COMPLEMENTARIO: '01-023',
      EXAMEN_DIFERIDO: '01-019',
      equivalenciasPendientes: false,
      totalEquivalencias: 0,
      ciclosBecasPendientes: [],
      loadingAranceles: false,
      loadingCuotas: false,
      actualizarCooldown: false,
      actualizarSegundos: 10,
      dialogCarnetGenerado: false,
      dialogRegistroIdiomas: false,
      dialogEsperaPago: false,
      dialogEsperaMessage: 'Esperando respuesta de ventana de pago.',
      dialogEsperaSubMessage: 'No cierre esta pestaña o el navegador.',
      dialogEsperaColor: 'primary',
      dialogBecaInfo: false,
      dialogBecaComp: false,
      dialogDuiInfo: false,
      dialogReiniciar: false,
      itemCantidad: 1,
      itemPrecio: 0,
      itemCodigo: '',
      arancelCantidad: false,
      arancelDescripcion: '',
      cuotaTipoBeca: null,
      cuotaDescuento: 0,
      totalSinDescuento: 0,
      totalConDescuento: 0,
      editedIndex: -1,
      popupRes: [],
      insertPagoRes: [],
      pagosRegistrados: [],
      ultimoPagoIdiomas: [],
      loadingPagosIdiomas: false,
      loadingPagos: false,
      searchPagos: '',
      headersIdioma: [
         {
            text: 'Idioma',
            value: 'idioma',
            class: 'titulo'
         },
         {
            text: 'Nivel',
            value: 'nivel',
            class: 'titulo'
         },
         {
            text: 'Programa',
            value: 'programaDescripcion',
            class: 'titulo'
         },
         {
            text: 'Opciones',
            value: 'opciones',
            sortable: false,
            width: '125',
            align: 'right',
            class: 'titulo'
         }
      ],
      headersPagos: [
         {
            text: 'Fecha de pago',
            value: 'fecha',
            class: 'titulo'
         },
         {
            text: 'Tipo de pago',
            value: 'tipoPago',
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Concepto',
            width: '275',
            value: 'concepto',
            class: 'titulo'
         },
         {
            text: 'Referencia',
            value: 'referencia',
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Autorizacion',
            value: 'autorizacion',
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Monto',
            value: 'total',
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Comp. Beca',
            value: 'compBeca',
            sortable: false,
            align: 'right',
            class: 'titulo'
         },
         {
            text: 'Comp. Pago',
            value: 'comprobante',
            sortable: false,
            align: 'right',
            class: 'titulo'
         }
      ],
      headersPagosIdiomas: [
         {
            text: 'Fecha de pago',
            value: 'fecha',
            class: 'titulo'
         },
         {
            text: 'Concepto',
            value: 'concepto',
            class: 'titulo'
         },
         {
            text: 'Monto',
            value: 'monto',
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Opciones',
            value: 'historial',
            sortable: false,
            align: 'right',
            class: 'titulo'
         }
      ],
      headersAranceles: [
         {
            text: 'Nombre',
            value: 'descripcion',
            class: 'titulo',
            sortable: false
         },
         {
            text: 'Monto',
            value: 'precioUnitario',
            class: 'titulo',
            align: 'right',
            sortable: false
         }
      ],
      headersAraComple: [
         {
            text: 'Nombre',
            value: 'descripcion',
            class: 'titulo',
            sortable: false
         },
         {
            text: 'Codigo',
            value: 'codigoMateria',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Materia',
            value: 'materia',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Sección',
            value: 'seccion',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Promedio',
            value: 'promedioCiclo',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Asistencia',
            value: 'asistenciaCiclo',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Fecha de pago',
            value: 'fechaDePago',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Monto',
            value: 'precio',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Opciones',
            value: 'opciones',
            sortable: false,
            width: '125',
            align: 'right',
            class: 'titulo'
         }
      ],
      headersAraDife: [
         {
            text: 'Nombre',
            value: 'descripcion',
            class: 'titulo',
            sortable: false
         },
         {
            text: 'Codigo',
            value: 'codigoMateria',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Materia',
            value: 'materia',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Sección',
            value: 'seccion',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Año',
            value: 'annio',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Ciclo',
            value: 'ciclo',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Periodo',
            value: 'periodo',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Nota',
            value: 'parcialNota',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Asistencia',
            value: 'asistencia',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Monto',
            value: 'precio',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Opciones',
            value: 'opciones',
            sortable: false,
            width: '125',
            align: 'right',
            class: 'titulo'
         }
      ],
      headersAra: [
         {
            text: 'Nombre',
            value: 'nombre',
            class: 'titulo',
            sortable: false
         },
         {
            text: 'Monto',
            value: 'precio',
            class: 'titulo',
            align: 'right',
            sortable: false
         },
         {
            text: 'Opciones',
            value: 'opciones',
            sortable: false,
            width: '125',
            align: 'right',
            class: 'titulo'
         }
      ],
      headersCuotas: [
         { text: 'Seleccionar', value: 'data-table-select', sortable: false },
         {
            text: 'Ciclo',
            value: 'periodoLectivo',
            class: 'titulo',
            align: 'center',
            sortable: false
         },
         { text: 'NPE', value: 'npe', class: 'titulo', sortable: false },
         {
            text: 'N° Cuota',
            value: 'cuota',
            class: 'titulo',
            align: 'center',
            sortable: false
         },
         {
            text: 'Fecha de vencimiento',
            value: 'fechaVencimiento',
            class: 'titulo',
            align: 'center',
            sortable: false
         },
         {
            text: 'Fecha de pago',
            value: 'fechaDePago',
            class: 'titulo',
            align: 'center',
            sortable: false
         },
         {
            text: 'Monto',
            value: 'monto',
            class: 'titulo',
            width: 130,
            align: 'center',
            sortable: false
         },
         {
            text: 'Estado',
            value: 'estado',
            class: 'titulo',
            align: 'center',
            sortable: false
         },
         {
            text: 'Opciones',
            value: 'opciones',
            sortable: false,
            width: '125',
            align: 'right',
            class: 'titulo'
         }
      ],
      detallesAranceles: [],
      headersAraFiltered: [],

      // Variables para validacion de query
      carnet: '',
      accesscode: '',
      poseeMora: true,
      verificado: false,
      loadingMessage: '',
      loadingContador: null,
      loadingSegundos: 0,
      loadingContadorHandle: null,
      loadingFechaHora: '',
      alumnoMessage: '',

      // Temporizador de sesión (7 minutos)
      sessionTimerHandle: null,
      countdownHandle: null,
      sessionCountdownSeconds: 420,
      sessionToken: null,
      timerPausadoEn: null,

      // Control de cupo
      sinCupo: false,
      cuposDisponibles: 0,
      cupoPollingHandle: null,
      cuentaSesion: -1,
      cuentaSesionHandle: null,

      // Variables de formularios
      dialogDemoTalonario: false,
      dialogPagoCuota: false,
      dialogPagoCuotaMultiple: false,
      dialogPagoArancel: false,
      dialogPagoIdioma: false,
      dialogReporteLoading: false,
      btnDetalleColor: 'primary white--text',
      talonario: [],
      aranceles: [],
      talonarioCache: {},
      periodoLectivo: [],
      recargo: 0,
      recargoIdiomas: 0,
      detalleIcon: 'fa-plus',
      dialogEliminarTalonario: false,
      dialogEliminarDetalle: false,
      fecha: vm.toISOLocal(new Date()).substr(0, 10),
      fechaAnulacion: vm.toISOLocal(new Date()).substr(0, 10),
      radiosBusqueda: 'r-numeroTalonario',
      radiosOption: 'r-individual',
      search: '',
      show: false,
      clienteId: null,
      stepNum: 1,

      // Propiedades talonarios
      cmbEstadoTalonario: [],

      // Talonario
      contratoId: '',
      selectSede: '',
      cmbSede: [],
      alumnoInfo: [],
      alumno: '',
      nombres: '',
      apellidos: '',
      configuracionPago: '',
      unidadEducativa: '',
      numeroTalonario: '',
      cicloDescripcion: '',
      gradoAcademico: 0,
      selectCarrera: '',
      selectArancel: '',
      cmbCarrera: [],
      carreraNombre: '',
      selectConfPago: '',
      cmbConfPago: [],
      cmbArancel: [],

      // Variables detalles de talonario
      detallecontratoId: '',
      detalles: [],
      detallesPendientes: [],
      cuotasSeleccionadas: [],
      cuotasPagoMultiple: [],
      detallePagoArancel: [],
      totalMora: '',
      npe: '',
      npes: [],
      detallesComprobantes: [],
      cuotaFacturada: false,
      fechaDePago: '',
      numeroCuota: '',
      selectEstadoDetalle: '',
      cmbEstadoDetalle: '',
      filtroCuotas: '',

      // Variables para serfinsa
      totalPagar: '',
      idTransaccion: '',
      tokenSerfinsa: '',
      tokenContabilidad: process.env.VUE_APP_TOKEN_CONTA,
      tokenIdiomas: process.env.VUE_APP_TOKEN_LIBRERIA,
      idPagos: [],

      // Variables para pago aranceles
      arancelCodigo: '',
      seccion: '',
      periodoDeCiclo: '',
      decanatoCodigo: '',
      materiaCodigo: '',
      materiaNombre: '',
      periodoDiferidos: '',
      loadingAranPagados: false,

      // Variables de modulo de idiomas
      disablePagoIdioma: false,
      nivelDeshabilitado: false,
      idiomaCodigoAlumno: '',
      idiomaCuota: '',
      idiomaNivel: '',
      idiomaMonto: '',
      idiomaProgramaId: '',
      idiomaProgramaDesc: '',
      idiomaProgramaCodigo: '',
      idiomaVencido: false,
      idiomaMesesDesdeUltimoModulo: 0,
      idiomaLimiteMesesInacividad: 0,
      idiomaNombre: '',
      idiomaCorreo:
         process.env.VUE_APP_SEDE == 'SA'
            ? 'idiomas@catolica.edu.sv'
            : 'english.cri@catolica.edu.sv',
      idiomaTelefono:
         process.env.VUE_APP_SEDE == 'SA' ? '2484-0614' : '2378-1520',
      cmbModuloIdiomas: [],
      cmbProgramas: [],
      nivelesProgramados: [],
      selectPrograma: '',
      selectProgramaArancel: '',
      validPagoProgramaArancel: true,
      validPagoIdioma: true,
      rulesPrograma: [(v) => !!v || 'Seleccione un programa'],

      // Variables adicionales para comprobante de pago
      autorizacion: '',
      referencia: '',
      resImprimir: [],

      // Otros
      read: 0,
      result: [],
      snackColor: 'primary',
      snackText: '',
      snackbar: false,
      valida: 0,
      verNuevo: 0,
      cicloNombre: '',
      ntalonario: '',
      nombrePago: '',
      carnetPago: '',
      numTarjeta: '',
      cvv: ''
   }),
   computed: {
      ...authComputed,
      tiempoRestanteFormato() {
         const mins = Math.floor(this.sessionCountdownSeconds / 60)
         const secs = this.sessionCountdownSeconds % 60
         return `${mins}:${secs.toString().padStart(2, '0')}`
      },
      debeComprobantes() {
         return this.detallesPendientes.some(
            (c) =>
               c.facturado &&
               c.tipoBeca != null &&
               c.seHaSubidoComprobante == null &&
               c.fechaDePago != 'PAGO BANCO'
         )
      },
      filteredCuotaArancel() {
         var res = []
         const DOCTORADO_MEDICINA = 110 //Codigo de Carrera
         const esDoctoradoMedSalud =
      (this.talonario?.gradoAcademico || '').trim().toUpperCase() ===
         'DOCTORADO EN MEDICINA' &&
      (this.talonario?.unidadEducativa || '').trim().toUpperCase() ===
         'FACULTAD DE CIENCIAS DE LA SALUD'

         this.aranceles.forEach((arancel) => {
            // Imprimiendo aranceles (U)nicos solo en primera cuota
            if (
               arancel.tipoCobro == 'U' &&
               this.numeroCuota == 1 &&
               !arancel.extraordinaria &&
               !arancel.procesoGraduacion &&
(!this.talonario.procesoGraduacion || esDoctoradoMedSalud)
            ) {
               res.push(arancel)
            }

            // Impriendo aranceles (R)ecurrentes en todas las cuotas
            if (
               arancel.tipoCobro == 'R' &&
               !arancel.extraordinaria &&
               !arancel.procesoGraduacion &&
               !this.talonario.procesoGraduacion
            ) {
               res.push(arancel)
            }

            // Impriendo arancel de proceso gracuadion si el talonario esta en proceso de graduacion
            if (
               arancel.tipoCobro == 'R' &&
               this.selectCarrera != DOCTORADO_MEDICINA &&
               !arancel.extraordinaria &&
               arancel.procesoGraduacion &&
               this.talonario.procesoGraduacion
            ) {
               res.push(arancel)
            }

            if (
               this.numeroCuota == 1 &&
               this.selectCarrera == DOCTORADO_MEDICINA &&
               !arancel.extraordinaria &&
               arancel.procesoGraduacion &&
               this.talonario.procesoGraduacion
            ) {
               res.push(arancel)
            } else if (
               arancel.tipoCobro == 'R' &&
               this.numeroCuota != 1 &&
               this.selectCarrera == DOCTORADO_MEDICINA &&
               !arancel.extraordinaria &&
               arancel.procesoGraduacion &&
               this.talonario.procesoGraduacion
            ) {
               res.push(arancel)
            }
         })

         // Si tiene recargo se anexa arancel de PAGO EXTEMPORANEO
         if (Number(this.recargo) > 0) {
            var pagoExtemporaneo = {}
            pagoExtemporaneo.descripcion = 'PAGO EXTEMPORANEO'
            pagoExtemporaneo.montoImpuesto = 0.0
            pagoExtemporaneo.precioUnitario = this.recargo
            //console.log(pagoExtemporaneo)
            res.push(pagoExtemporaneo)
         } else {
            var recargoExonerado = {}
            recargoExonerado.descripcion = 'RECARGO EXONERADO'
            recargoExonerado.montoImpuesto = 0.0
            recargoExonerado.precioUnitario = 0.0
            //console.log(recargoExonerado)
            res.push(recargoExonerado)
         }
         return res
      },
      maxEquivalencias() {
         return this.selectArancel == this.EQUIVALENCIA_EXTERNA ||
            this.selectArancel == this.EQUIVALENCIA_INTERNA
            ? this.totalEquivalencias
            : null
      },
      //Nombre de Carrera agrega validacion si trae codigo 803 se cambiara la carrera a Licenciatura en gastronomía hosteleria
    nombreCarrera() {
  // Caso especial SOLO visual
  if (String(this.codigoCarreraOriginal) === '3803') {
    return 'LICENCIATURA EN GASTRONOMIA Y HOSTELERIA'
  }

  // Caso normal (3 dígitos)
  const carrera = this.cmbCarrera.find(
    (obj) => String(obj.codigo) === String(this.selectCarrera)
  )

  return carrera
    ? carrera.nombre
    : 'No se encontro la carrera del estudiante'
},
      listaPosgrados() {
         return new Set([
            'MAESTRIA EN GERENCIA DE SERVICIO DE SALUD',
            'MAESTRIA EN DIRECCION ESTRATEGICA DE EMPRESAS',
            'MAESTRIA EN ASESORIA EDUCATIVA',
            'MAESTRIA EN ESTUDIOS JUDICIALES',
            'MAESTRIA EN ATENCION INTEGRAL DE LA PRIMERA INFANCIA',
            'MAESTRIA EN GERENCIA Y GESTION AMBIENTAL',
            'MAESTRIA EN GESTION Y DESARROLLO TURISTICO',
            'MAESTRIA EN SEGURIDAD INFORMATICA',
            'MAESTRIA EN SEGURIDAD INFORMATICA - VIRTUAL',
            'MAESTRIA EN INVESTIGACION EDUCATIVA',
            'MAESTRIA EN GERENCIA Y GESTION AMBIENTAL - VIRTUAL',
            'DOCTORADO EN EDUCACION',
            'DOCTORADO EN CIENCIAS AMBIENTALES',
            'DOCTORADO EN DIRECCION ESTRATEGICA DE EMPRESAS',
            'DOCTORADO EN INGENIERIA AMBIENTAL'
         ])
      }

   },
   watch: {
      verificado(val) {
         if (val === true) {
            this.registrarSesionEnServidor()
         }
      },
      dialogEsperaPago(val) {
         if (val) {
            // Popup de Serfinsa abierto: pausar el timer
            this.timerPausadoEn = Date.now()
            this.cancelarTemporizadores()
         } else if (this.timerPausadoEn !== null) {
            // Popup cerrado: ajustar el inicio de sesión por el tiempo pausado y reanudar
            const pausaDuracion = Date.now() - this.timerPausadoEn
            this.timerPausadoEn = null
            const SESSION_KEY = 'alumno_session_start'
            const inicio = sessionStorage.getItem(SESSION_KEY)
            if (inicio) {
               sessionStorage.setItem(SESSION_KEY, (parseInt(inicio) + pausaDuracion).toString())
            }
            this.iniciarTemporizadorAlumno()
         }
      },
      totalPagar(val) {
         if (val >= 200 && this.alumnoInfo.dui.trim() == '') {
            setTimeout(() => {
               this.dialogDuiInfo = true
            }, 300)
         }
      },
      selectPrograma(val) {
         if (val != '' && val != null) {
            this.disablePagoIdioma = true
            var idiomaCodigo = this.cmbProgramas.find(
               (obj) => obj.programaId == val
            ).codigo
            this.nivelDeshabilitado =
               this.nivelesProgramados.find(
                  (obj) =>
                     obj.codigo == idiomaCodigo && obj.nivel == this.idiomaNivel
               ) != undefined
                  ? false
                  : true
            this.cupoAgotado =
               this.cmbProgramas.find((obj) => obj.programaId == val).cupos ==
                  0 && this.idiomaNivel == 1
                  ? true
                  : false
            this.disablePagoIdioma =
               this.nivelDeshabilitado || this.cupoAgotado ? true : false
            this.getRecargoIdiomas(val)
         }
      },
     selectCarrera(val) {
  const carrera = this.cmbCarrera.find(
    (obj) => String(obj.codigo) === String(val)
  )

  //  Caso especial SOLO visual (usa el código ORIGINAL)
  if (String(this.codigoCarreraOriginal) === '3803') {
    this.carreraNombre = 'LICENCIATURA EN GASTRONOMIA Y HOSTELERIA'
    return
  }

  // Caso normal
  if (carrera) {
    this.carreraNombre = carrera.nombre
  } else {
    this.carreraNombre = 'CARRERA NO ENCONTRADA'
  }
},


      itemCantidad(val) {
         if (this.stepNum == 3) {
            this.totalPagar = this.toFixedRegex(this.itemPrecio * val, 2)

            if (
               this.totalEquivalencias > 0 &&
               val == this.totalEquivalencias &&
               (this.selectArancel == this.EQUIVALENCIA_EXTERNA ||
                  this.selectArancel == this.EQUIVALENCIA_INTERNA)
            ) {
               let checkComplementoMensaje =
                  this.totalEquivalencias > 1 ? 'equivalencias' : 'equivalencia'

               this.showSnack(
                  `Solo tiene pendiente ${this.totalEquivalencias} ${checkComplementoMensaje}`,
                  'snackError'
               )
            }
         }
      },
      // Revisar si algun pago ya se encuentra registrado exitosamente en tabla de pagos interna
      detallesPendientes(val) {
         // Obtener ultimo ciclo del final de la tabla
         if (val.length > 0) {
            this.cicloActual = val[val.length - 1].periodoLectivo
         }
         // Detectar cuotas sin NPE
         const sinNpe = val.filter(c => !c.npe || c.npe.trim() === '')
         if (sinNpe.length > 0) {
            this.dialogNpeFaltante = true
         }
         // Detectar cuotas duplicadas (mismo NPE más de una vez)
         const npes = val.map(c => c.npe).filter(n => n && n.trim() !== '')
         const npesDuplicados = npes.filter((n, i) => npes.indexOf(n) !== i)
         if (npesDuplicados.length > 0) {
            this.dialogCuotasDuplicadas = true
         }
      },
      // Revisar si algun pago de comples o diferidos ya se encuentra registrado exitosamente en tabla de pagos interna
      detallesAranceles(val) {
         var today = this.toISOLocal(new Date()).substr(0, 10)
         // Revisando comples o diferidos ya pagados
         const COMPLEMENTARIO = '01-023'
         const DIFERIDO = '01-019'
         if (
            this.selectArancel == COMPLEMENTARIO ||
            this.selectArancel == DIFERIDO
         ) {
            if (val.length > 0) this.loadingAranPagados = true

            val.forEach((arancel) => {
               axios
                  .get(
                     'api/Pago?Carnet=' +
                        this.carnet +
                        '&Year=' +
                        today.substr(0, 4) +
                        '&ResponseCode=00&CodigoArancel=' +
                        arancel.codigo +
                        '&MateriaCodigo=' +
                        arancel.codigoMateria +
                        '&Seccion=' +
                        arancel.seccion +
                        '&Ciclo=' +
                        (today <= today.substr(0, 4) + '-07-31' ? 1 : 2)
                  )
                  .then((response) => {
                     if (response.data.length > 0) {
                        var res = response.data[0]
                        // Ya se registro un pago autorizado
                        arancel.facturado = true
                        arancel.fechaDePago = res.fecha
                     }
                  })
                  .catch(() => {
                     //console.log(error)
                  })
                  .finally(() => {
                     this.loadingAranPagados = false
                  })
            })
         }
      },
      // Esperando respuesta de callback de Serfinsa
      'mapState.callBackPago'(value) {
         if (value) {
            this.popupRes = value
            // Registrar la respuesta de Serfinsa en el backend
            axios.post('api/SerfinsaResponse', {
               satisFactorio: value.Codigo === '00',
               codigo: value.Codigo,
               mensaje: value.Mensaje,
               fecha: value.Fecha,
               clientIdTransaction: this.idTransaccion,
               maskPan: value.MaskPan,
               cardHolder: value.CardHolder,
               medioPago: value.MedioPago,
               numeroReferencia: value.NumeroReferencia,
               numeroAutorizacion: value.NumeroAutorizacion,
               comentarioImplementacion: 'linea de registro nueva'
            }).catch(() => {
               // No bloquear el flujo del comprobante si falla el registro
            })
            this.dialogEsperaColor = 'snackInfo'
            this.dialogEsperaMessage = 'Generando comprobante de pago...'
            this.dialogEsperaSubMessage =
               'No cierre esta pestaña o el navegador.'
            this.showSnack(
               'Generando comprobante de pago, por favor espere...',
               'snackInfo'
            )
            // Al recibir una respuesta del popup generar comprobante
            if (this.stepNum == 2 && value.Codigo == '00') {
               // Descargar comprobante de pago cuotas
               this.imprimirComprobantePago(
                  this.insertPagoRes,
                  4500,
                  'save',
                  'cuota'
               ).then(() => {
                  // Refrescar lista de pagos
                  this.dialogEsperaPago = false
                  this.listarCuotasPendientes()
                  this.cuotasSeleccionadas = []
                  this.closePagoCuota()
                  this.closePagoCuotaMultiple()
                  this.showSnack(
                     'Tu pago de cuota/s se ha registrado correctamente!',
                     'snackSuccess'
                  )
               })
            } else if (this.stepNum == 3 && value.Codigo == '00') {
               // Descargar comprobante de pago de arancel
               this.imprimirComprobantePago(
                  this.insertPagoRes,
                  4500,
                  'save',
                  'arancel'
               ).then(() => {
                  // Refrescar lista de aranceles
                  this.dialogEsperaPago = false
                  this.closePagoArancel()
                  this.irPagoAranceles()
                  this.showSnack(
                     'Tu pago de arancel se ha registrado correctamente!',
                     'snackSuccess'
                  )
               })
            } else if (this.stepNum == 4 && value.Codigo == '00') {
               // Descargar comprobante de pago de idiomas
               this.idiomaNivel = this.insertPagoRes[0].nivel
               this.idiomaProgramaDesc = this.insertPagoRes[0].programa
               this.idiomaNombre = this.insertPagoRes[0].idioma
               this.imprimirComprobantePago(
                  this.insertPagoRes,
                  4500,
                  'save',
                  'arancel'
               ).then(() => {
                  // Refrescar lista de aranceles
                  this.dialogEsperaPago = false
                  this.closePagoIdioma()
                  this.irPagoIdiomas()
                  this.showSnack(
                     'Tu pago de idiomas se ha registrado correctamente!',
                     'snackSuccess'
                  )
               })
            } else {
               this.showSnack(
                  'Tu pago no se realizó correctamente.',
                  'snackError'
               )
            }
         }
      },
      // Mostrar aranceles en datatable
      selectArancel(val) {
         if (val != '') {
            this.loadingAranceles = true
            this.selectProgramaArancel = null
            this.listarAranceles()
         }
      }
   },
   created() {
      // Obteniendo imagenes base64 para impresiones
      this.toDataURL('/assets/logo_u_black-300.png').then((result) => {
         this.logo64 = result
      })
      this.toDataURL('/assets/CdA_black-300.png').then((result) => {
         this.cda64 = result
      })
      this.toDataURL('/assets/sello-cancelado-red-400.png').then((result) => {
         this.selloCancelado = result
      })
      this.toDataURL('/assets/sello-cancelado-nodate-400.png').then(
         (result) => {
            this.selloCanceladoNoDate = result
         }
      )
      this.toDataURL('/assets/empty-400.png').then((result) => {
         this.emptyImage = result
      })

      // Al cargar el componente se carga las detalles
      this.getQueryVariables()
   },
   mounted() {
      // Agregando Serfinsa Pay
      // https://www.serfinsacheckout.com/Scripts/Serfinsa.Pay.js
      // https://test.serfinsacheckout.com:8080/Scripts/Serfinsa.Pay.js
      let serfinsaScript = document.createElement('script')
      serfinsaScript.setAttribute('src', process.env.VUE_APP_SERFINSA_URL)
      document.head.appendChild(serfinsaScript)

      // pagehide se dispara al cerrar la pestaña o el navegador (beforeDestroy no lo hace)
      window.addEventListener('pagehide', this.liberarSesionEnServidor)
   },
   beforeDestroy() {
      window.removeEventListener('pagehide', this.liberarSesionEnServidor)
      this.liberarSesionEnServidor()
      this.cancelarTemporizadores()
      this.detenerPollingCupos()
      if (this.cuentaSesionHandle) clearInterval(this.cuentaSesionHandle)
      if (this.loadingContadorHandle) clearInterval(this.loadingContadorHandle)
      if (this.horaActualHandle) clearInterval(this.horaActualHandle)
   },
   methods: {
      registrarSesionEnServidor() {
         // Admin y user no ocupan cupo ni registran sesión
         if (this.oidcUser && (this.oidcUser.role === 'admin' || this.oidcUser.role === 'user')) {
            this.detenerPollingCupos()
            this.sinCupo = false
            return
         }

         const SESSION_TOKEN_KEY = 'alumno_session_token'
         const tokenExistente = sessionStorage.getItem(SESSION_TOKEN_KEY)

         if (tokenExistente) {
            // El alumno refrescó la página: verificar que el token sigue activo
            axios.get(`api/SesionAlumno/validar?token=${tokenExistente}`)
               .then(() => {
                  // Token válido: reutilizarlo sin registrar una sesión nueva
                  this.sessionToken = tokenExistente
                  this.detenerPollingCupos()
                  this.sinCupo = false
                  this.iniciarTemporizadorAlumno()
               })
               .catch(() => {
                  // Token ya no existe en el servidor (sesión expiró): registrar nuevo
                  sessionStorage.removeItem(SESSION_TOKEN_KEY)
                  this.registrarSesionNueva()
               })
         } else {
            this.registrarSesionNueva()
         }
      },
      registrarSesionNueva() {
         const SESSION_TOKEN_KEY = 'alumno_session_token'
         axios.post(`api/SesionAlumno?carnet=${this.carnet}`)
            .then((response) => {
               this.sessionToken = response.data.token
               sessionStorage.setItem(SESSION_TOKEN_KEY, response.data.token)
               // Cupo obtenido: detener polling y arrancar el timer
               this.detenerPollingCupos()
               this.sinCupo = false
               this.iniciarTemporizadorAlumno()
            })
            .catch((error) => {
               if (error.response && error.response.status === 409) {
                  // Sin cupo: activar pantalla de espera y polling
                  this.sinCupo = true
                  this.cuposDisponibles = 0
                  this.iniciarPollingCupos()
               }
            })
      },
      liberarSesionEnServidor() {
         if (!this.sessionToken) return
         const token = this.sessionToken
         this.sessionToken = null
         // No se borra sessionStorage aquí: si es un refresh, la recarga lo reutiliza.
         // Si es un cierre real de pestaña, el navegador borra sessionStorage automáticamente.
         const url = '/api/SesionAlumno/' + token
         try { fetch(url, { method: 'DELETE', keepalive: true }) } catch (e) {}
         axios.delete(url).catch(() => {})
      },
      iniciarPollingCupos() {
         this.detenerPollingCupos()
         this.cupoPollingHandle = setInterval(() => {
            // Si ya hay una cuenta regresiva activa no iniciamos otra
            if (this.cuentaSesionHandle) return
            axios.get(`api/SesionAlumno/cupos?carnet=${this.carnet}`)
               .then((response) => {
                  this.cuposDisponibles = response.data.disponibles
                  if (response.data.disponibles > 0) {
                     this.iniciarCuentaRegresivaSesion()
                  }
               })
               .catch(() => {})
         }, 10000)
      },
      iniciarCuentaRegresivaSesion() {
         if (this.cuentaSesionHandle) return
         this.detenerPollingCupos()
         this.cuentaSesion = 5
         this.cuentaSesionHandle = setInterval(() => {
            this.cuentaSesion--
            if (this.cuentaSesion <= 0) {
               clearInterval(this.cuentaSesionHandle)
               this.cuentaSesionHandle = null
               this.cuentaSesion = -1
               this.registrarSesionEnServidor()
            }
         }, 1000)
      },
      detenerPollingCupos() {
         if (this.cupoPollingHandle) {
            clearInterval(this.cupoPollingHandle)
            this.cupoPollingHandle = null
         }
      },
      iniciarTemporizadorAlumno() {
         // Admin y user no tienen límite de tiempo
         if (this.oidcUser && (this.oidcUser.role === 'admin' || this.oidcUser.role === 'user')) {
            return
         }


         const SESSION_KEY = 'alumno_session_start'
         const EXPIRED_KEY = 'alumno_session_expired'
         const DURACION_MS = 7 * 60 * 1000 // 7 minutos

         // Si la sesión ya expiró antes, redirigir de inmediato sin dejar volver
         if (sessionStorage.getItem(EXPIRED_KEY)) {
            window.location.replace('https://regcri.catolica.edu.sv/appalucri/Login/Login?ReturnUrl=%2fappalucri')
            return
         }

         let startTime = sessionStorage.getItem(SESSION_KEY)
         if (!startTime) {
            startTime = Date.now()
            sessionStorage.setItem(SESSION_KEY, startTime.toString())
         } else {
            startTime = parseInt(startTime)
         }

         const elapsed = Date.now() - startTime
         const remaining = DURACION_MS - elapsed

         if (remaining <= 0) {
            this.expiracionSesionAlumno()
            return
         }

         this.sessionCountdownSeconds = Math.ceil(remaining / 1000)
         this.cancelarTemporizadores()

         this.countdownHandle = setInterval(() => {
            this.sessionCountdownSeconds--
            if (this.sessionCountdownSeconds <= 0) {
               clearInterval(this.countdownHandle)
               this.countdownHandle = null
            }
         }, 1000)

         this.sessionTimerHandle = setTimeout(() => {
            this.expiracionSesionAlumno()
         }, remaining)
      },
      expiracionSesionAlumno() {
         this.liberarSesionEnServidor()
         this.cancelarTemporizadores()
         sessionStorage.removeItem('alumno_session_start')
         sessionStorage.removeItem('alumno_session_token')
         sessionStorage.setItem('alumno_session_expired', '1')
         window.location.replace('https://regcri.catolica.edu.sv/appalucri/Login/Login?ReturnUrl=%2fappalucri')
      },
      cancelarTemporizadores() {
         if (this.sessionTimerHandle) {
            clearTimeout(this.sessionTimerHandle)
            this.sessionTimerHandle = null
         }
         if (this.countdownHandle) {
            clearInterval(this.countdownHandle)
            this.countdownHandle = null
         }
      },

      buildDetalleParaModal(cuota) {
  const esDoctoradoMedSalud =
    (this.talonario?.gradoAcademico || '').trim().toUpperCase() === 'DOCTORADO EN MEDICINA' &&
    (this.talonario?.unidadEducativa || '').trim().toUpperCase() === 'FACULTAD DE CIENCIAS DE LA SALUD'

  // ⚠️ Si no es el caso especial, NO TOCAMOS NADA
  if (!(esDoctoradoMedSalud && Number(cuota.cuota) === 1)) {
    return cuota.detallePago || []
  }

  // Caso especial: usamos detalleContrato (igual que el voucher)
  const aranceles = this.talonario?.detalleContrato || []

  return aranceles
    .filter(a => !a.extraordinaria)
    .filter(a => {
      if (a.tipoCobro === 'U') {
        return !a.procesoGraduacion && Number(cuota.cuota) === 1
      }
      if (a.tipoCobro === 'R') {
        return a.procesoGraduacion === true
      }
      return false
    })
    .map(a => ({
      nombre: a.descripcion.replaceAll('_', ' '),
      monto: (Number(a.precioUnitario) + Number(a.montoImpuesto)).toFixed(2)
    }))
},
      reiniciarNivel() {
         axios
            .put('api/ProgramaIdioma/ReiniciarNivel', {
               programa: this.idiomaProgramaCodigo,
               year: Number(this.toISOLocal(new Date()).substr(0, 4)),
               codigoIdiomas: this.idiomaCodigoAlumno,
               cuota: this.idiomaCuota
            })
            .then(() => {
               this.dialogReiniciar = false
               this.showSnack(
                  'Nivel reiniciado correctamente. Refrescando...',
                  'snackSuccess'
               )
               setTimeout(() => {
                  this.refreshPage()
               }, 4000)
            })
            .catch(() => {
               this.showSnack('Algo ha ido mal...', 'snackError')
            })
      },
      closeCarnetGenerado() {
         this.dialogCarnetGenerado = false
         this.refreshPage()
      },
      showCarnetGenerado(carnet) {
         console.log(carnet)
         this.dialogCarnetGenerado = true
      },
      listarProgramas(idiomaId) {
         this.cmbProgramas = []
         axios
            .get('api/ProgramaIdioma?activo=true&idiomaId=' + idiomaId)
            .then((response) => {
               this.cmbProgramas = response.data
            })
            .catch((error) => {
               console.log(error)
            })
      },
      validatePagoIdiomas() {
         if (this.$refs.formPagoIdioma.validate()) {
            this.initPago()
         }
      },
      checkRangoAlto() {
         if (this.oidcUser) {
            return Number(this.oidcUser.nivelasesor) > 1 ||
               this.oidcUser.role == 'admin'
               ? true
               : false
         } else {
            return false
         }
      },
      irPagoAranceles() {
         axios
            .get('api/Arancel/publicos?EsPublico=false&carnet=' + this.carnet)
            .then((response) => {
               this.cmbArancel = response.data.sort(this.dynamicSort('nombre'))
            })
            .catch(() => {
               //console.log(error)
            })
            .finally(() => {
               this.selectArancel = ''
               this.detallesAranceles = []
               this.stepNum = 3
            })
      },
      irPagoIdiomas() {
         var idiomaId = null
         this.loadingPagosIdiomas = true
         axios
            .get('api/pagosIdiomas/codigo?codigo=' + this.carnet)
            .then((response) => {
               this.cmbModuloIdiomas = []
               this.cmbModuloIdiomas.push(response.data)
               switch (response.data.idioma) {
                  case 'EN':
                     idiomaId = 2
                     break
                  case 'FR':
                     idiomaId = 6
                     break
                  default:
                     idiomaId = null
                     break
               }
            })
            .catch(() => {
               this.cmbModuloIdiomas = []
               //console.log(error)
            })
            .finally(() => {
               axios
                  .get(
                     `api/Pago?Carnet=${this.carnet}&ResponseCode=00&BotonDePagoId=2`
                  )
                  .then((response) => {
                     var pagosIdiomas = response.data
                     var last =
                        pagosIdiomas.length > 0
                           ? pagosIdiomas[pagosIdiomas.length - 1]
                           : null
                     this.ultimoPagoIdiomas = []
                     if (last != null) {
                        this.ultimoPagoIdiomas.push(last)
                     }
                  })
                  .finally(() => {
                     if (this.cmbModuloIdiomas.length > 0) {
                        axios
                           .get(
                              'api/ProgramaIdioma?activo=true&idiomaId=' +
                                 idiomaId
                           )
                           .then((response) => {
                              this.cmbProgramas = []
                              this.cmbProgramas = response.data
                           })
                           .finally(() => {
                              axios
                                 .get('api/pagosIdiomas/niveles-programados')
                                 .then((response) => {
                                    this.nivelesProgramados = response.data
                                 })
                                 .finally(() => {
                                    this.loadingPagosIdiomas = false
                                    this.stepNum = 4
                                 })
                           })
                     } else {
                        this.loadingPagosIdiomas = false
                        this.stepNum = 4
                     }
                  })
            })
      },
      verificarInfoBeca() {
         var debeInfo = false
         if (this.countBeca < this.ciclosBecasPendientes.length) {
            const ciclo = this.ciclosBecasPendientes[this.countBeca]
            axios
               .get(`api/Beca?Carnet=${this.carnet}&PeriodoLectivo=${ciclo}`)
               .then((response) => {
                  if (response.data.length > 0) {
                     this.poseeBecaActiva = true
                     if (response.data[0].dui == null && this.stepNum == 2) {
                        if (!this.checkRangoAlto()) {
                           this.cicloBeca = ciclo
                           debeInfo = true
                        } else {
                           this.showSnack(
                              'El alumno debe info. de beca ' + ciclo,
                              'snackWarning'
                           )
                        }
                     }
                  }
               })
               .catch(() => {
                  //console.log(error)
               })
               .finally(() => {
                  if (debeInfo) {
                     this.dialogBecaInfo = true
                     this.countBeca = 0
                  } else {
                     this.countBeca++
                     this.verificarInfoBeca()
                  }
               })
         }
      },
      infoBecaActualizada() {
         //console.log(e)
         this.listarCuotasPendientes()
      },
      infoDuiActualizado() {
         this.getInfoAlumno()
      },
      refreshPage() {
         location.reload()
      },
      openImage(url) {
         window.open(process.env.VUE_APP_CLIENTE + url, '_blank')
      },
      // Ir a step 2
      listarCuotas() {
         this.stepNum = 2
         if (this.detallesPendientes.length === 0 && !this.loadingCuotas) {
            this.loadingCuotas = true
            this.listarCuotasPendientes()
         }
      },
      // Generar concepto comprobantes
      generarConcepto(item) {
         if (item.tipoPago == 'Cuota' && item.cantidad > 1) {
            return (
               'Pago de cuotas multiple. ' +
               item.concepto +
               ' + otras ' +
               (item.cantidad - 1).toString() +
               ' cuotas.'
            )
         } else if (item.tipoPago == 'Arancel' && item.cantidad > 1) {
            var esGraduacion = item.detalle.find(
               (el) =>
                  el.arancelCodigo == '01-020' || el.arancelCodigo == '02-062'
            )

            if (esGraduacion != undefined) {
               var esMaestria = item.detalle.find(
                  (el) => el.arancelCodigo == '02-062'
               )
               return esMaestria
                  ? 'Pago de aranceles de graduación maestria'
                  : 'Pago de aranceles de graduación'
            } else {
               return item.concepto + ' x ' + item.cantidad
            }
         } else if (
            item.tipoPago == 'Arancel' &&
            item.detalle[0].materiaCodigo != ''
         ) {
            return item.concepto + ' ' + item.detalle[0].materiaCodigo
         } else {
            return item.concepto
         }
      },
      // Listar pagos
      listarPagos() {
         this.stepNum = 5
         this.loadingPagos = true
         this.pagosRegistrados = []
         axios
            .get(`api/pago/comprobantes?carnet=${this.carnet}`)
            .then((response) => {
               this.pagosRegistrados = response.data
               this.loadingPagos = false
            })
            .catch(() => {
               //console.log(error)
            })
      },
      // Copiar al portapapeles
      copyToClip(value) {
         this.copyStringToClipboard(value)
         this.showSnack('NPE copiado al portapapeles', 'snackInfo')
      },
      // Obtener estado del sistema
      obtenerEstadoSistema() {
         if (this.configuracionCargada) return
         // Estado de periodo de diferidos
         axios
            .get('api/Configuracion/periodoDiferidos')
            .then((response) => {
               //console.log(response)
               if (
                  response.data.valor.trim() != '' &&
                  response.data.valor != null
               ) {
                  this.periodoDiferidos = response.data.valor
               } else {
                  this.periodoDiferidos = ''
               }
            })
            .catch(() => {
               //console.log(error)
            })
         // Estado de pagos habilitados
         axios
            .get('api/Configuracion/pagosEnLinea')
            .then((response) => {
               //console.log(response)
               if (response.data.valor == 'true') {
                  this.pagosDeshabilitados = false
                  if (this.horaActualHandle) {
                     clearInterval(this.horaActualHandle)
                     this.horaActualHandle = null
                  }
               } else {
                  this.pagosDeshabilitados = true
                  this.mantenimientoDesde = response.headers['x-mantenimiento-desde'] || ''
                  if (!this.horaActualHandle) {
                     this.horaActual = new Date().toLocaleString('es-SV', { dateStyle: 'full', timeStyle: 'medium' })
                     this.horaActualHandle = setInterval(() => {
                        this.horaActual = new Date().toLocaleString('es-SV', { dateStyle: 'full', timeStyle: 'medium' })
                     }, 1000)
                  }
                  // Si el alumno aún no está verificado, redirigir a pantalla de mantenimiento
                  if (!this.verificado) {
                     this.$router.push({
                        name: 'mantenimiento',
                        query: {
                           carnet: this.carnet,
                           desde: this.mantenimientoDesde,
                           accesscode: this.$route.query.accesscode
                        }
                     })
                  }
               }
            })
            .catch(() => {
               //console.log(error)
            })
         // Estado de pagos de idiomas habilitados
         axios
            .get('api/Configuracion/pagosIdiomas')
            .then((response) => {
               //console.log(response)
               if (response.data.valor == 'true') {
                  this.pagosIdiomasDeshabilitados = false
               } else {
                  if (this.checkRangoAlto()) {
                     this.pagosIdiomasDeshabilitados = false
                  } else {
                     this.pagosIdiomasDeshabilitados = true
                  }
               }
            })
            .catch(() => {
               //console.log(error)
            })
         // Mensaje desde DB
         axios
            .get('api/Configuracion/mensaje')
            .then((response) => {
               if (
                  response.data.valor.trim() != '' &&
                  response.data.valor != null
               ) {
                  this.mensajeImportante = response.data.valor
                  this.mostrarMensaje = true
               } else {
                  this.mostrarMensaje = false
                  this.mensajeImportante = ''
               }
            })
            .catch(() => {
               //console.log(error)
            })
         this.configuracionCargada = true
      },
      // Validar clic de checkbox
      checkCondition(event, item, isSelected) {
         for (let i = 0; i < this.detallesPendientes.length; i++) {
            const el = this.detallesPendientes[i]
            // Iterar hasta item seleccionado validando que la cuota no este
            // facturada, sea diferente del npe seleccionado y no se encuentre en el arreglo
            // de cuotas seleccionadas aun
            if (
               !el.facturado &&
               el.npe != item.npe &&
               !this.cuotasSeleccionadas.includes(el)
            ) {
               this.showSnack(
                  'No puedes dejar cuotas intermedias sin marcar',
                  'snackWarning'
               )
               return false
            }
            if (el.npe == item.npe) {
               // Validar que solo se pueda desmarcar ultima cuota del arreglo
               if (
                  isSelected &&
                  this.cuotasSeleccionadas[
                     this.cuotasSeleccionadas.length - 1
                  ] != item
               ) {
                  this.showSnack(
                     'No puedes desmarcar cuotas intermedias',
                     'snackWarning'
                  )
                  return true
               } else {
                  return event
               }
               break
            }
         }
      },
      // Logica de disabled de datatable
      disabledCuota(item, ignoreFacturado = false) {
         // Si tiene una cuota con beca pagada y aun no envia el formulario deshabilitar todo
         if (this.debeComprobantes) {
            return true
         }

         // Si ya pago deshabilitar
         if (item.facturado && !ignoreFacturado) {
            return true
         } else if (item.facturado && ignoreFacturado) {
            return false
         }

         // Si es ciclo III no deshabilitar
         if (item.periodoLectivo.includes('III-')) {
            return false
         }

         // Si tiene cuotas de ciclos pasados, deshabilitar periodo actual
         if (
            this.detallesPendientes.some(
               (c) => c.periodoLectivo != this.cicloActual && !c.facturado
            )
         ) {
            if (item.periodoLectivo == this.cicloActual) {
               // Si es del ciclo actual deshabilitar
               return true
            } else {
               // Si no deshabilitar en orden
               for (let i = 0; i < this.detallesPendientes.length; i++) {
                  if (this.detallesPendientes[i].npe == item.npe) {
                     // Validando si el primer item ya esta facturado
                     if (i == 0 && this.detallesPendientes[i].facturado) {
                        return true
                     }
                     // Validando a partir del segundo item que el anterio ya este facturado
                     if (i > 0 && !this.detallesPendientes[i - 1].facturado) {
                        return true
                     }
                  }
               }
            }
         } else {
            // Si solo tiene cuotas del periodo actual, permitir todo
            // siempre y cuando ya este pagada la matricula
            if (
               this.detallesPendientes.some(
                  (c) =>
                     c.periodoLectivo == this.cicloActual &&
                     !c.facturado &&
                     c.cuota == 1
               )
            ) {
               return item.cuota > 1 ? true : false
            } else {
               return false
            }
         }
      },
      // Logica de disabled de datatable
      disabledArancel(item) {
         // Si son complementarios o diferidos validar pago y disabled
         if (item.codigo == '01-023' || item.codigo == '01-019') {
            // Si ya pago deshabilitar
            if (item.facturado) {
               return true
            }
         } else {
            // Aranceles normales siempre estan disponibles
            return false
         }
      },
      // Inicializa proceso de pago al hacer clic en boton PAGAR
      initPago() {
         this.insertPagoRes = []
         this.popupRes = []
         this.showSnack(
            'Abriendo ventana de pago, por favor espere...',
            'snackInfo'
         )
         this.dialogEsperaColor = 'primary'
         this.dialogEsperaMessage = 'Esperando respuesta de ventana de pago.'
         this.dialogEsperaSubMessage =
            'No cierre esta pestaña o el navegador durante su proceso de pago. Si cerró la ventana de pago y desea quitar este mensaje, haga clic aquí: '
         this.dialogEsperaPago = true

         // Generar un id de transaccion
         axios
            .post('api/Pago/transaccion', {
               token: process.env.VUE_APP_TOKEN_TRANS
            })
            .then((response) => {
               if (response.status == 201) {
                  this.idTransaccion = response.data.transactionId
                  // Al crearse un idTransaccion se insertan los pagos vacios a espera de respuesta de Sersfisa
                  if (this.stepNum == 2) {
                     // POST DE PAGO DE CUOTAS
                     axios
                        .post('api/Pago/cuota', {
                           transaccionId: this.idTransaccion,
                           referencia: null,
                           autorizacion: null,
                           responseCode: null,
                           responseName: null,
                           maskPan: null,
                           cuotas: this.npes,
                           botonDePagoId: 1
                        })
                        .then((response) => {
                           if (response.status == 201) {
                              // Llamar a popup de pago de serfinsa
                              this.insertPagoRes = response.data
                              this.tokenSerfinsa = this.tokenContabilidad
                              setTimeout(() => {
                                 $('#btPagar').trigger('click')
                              }, 300)
                           } else {
                              this.showSnack(
                                 'El sistema no pudo inicializar su proceso de pago.',
                                 'snackError'
                              )
                           }
                        })
                        .catch(() => {
                           this.showSnack(
                              'El sistema no pudo inicializar su proceso de pago.',
                              'snackError'
                           )
                        })
                  } else if (this.stepNum == 3) {
                     //POST DE PAGO DE ARANCEL
                     axios
                        .post('api/Pago/otroarancel', {
                           alumnoCarnet: this.carnet.trim(),
                           arancelCodigo: this.arancelCodigo,
                           transaccionId: this.idTransaccion,
                           referencia: null,
                           autorizacion: null,
                           responseCode: null,
                           responseName: null,
                           maskPan: null,
                           seccion: this.seccion,
                           periodoDeCiclo: this.periodoDeCiclo,
                           decanatoCodigo: this.decanatoCodigo,
                           materiaCodigo: this.materiaCodigo,
                           cantidad: this.itemCantidad,
                           programaIdiomaId: this.selectProgramaArancel,
                           botonDePagoId: 1
                        })
                        .then((response) => {
                           if (response.status == 201) {
                              // Llamar a popup de pago de serfinsa
                              this.insertPagoRes = response.data
                              this.tokenSerfinsa = this.tokenContabilidad
                              setTimeout(() => {
                                 $('#btPagar').trigger('click')
                              }, 300)
                           } else {
                              this.showSnack(
                                 'El sistema no pudo inicializar su proceso de pago.',
                                 'snackError'
                              )
                           }
                        })
                        .catch(() => {
                           this.dialogEsperaPago = false
                           this.showSnack(
                              'No es posible registrar su intento de pago.',
                              'snackError'
                           )
                        })
                  } else if (this.stepNum == 4) {
                     //POST DE PAGO DE IDIOMAS

                     axios
                        .post('api/Pago/otroarancel', {
                           alumnoCarnet: this.carnet.trim(),
                           arancelCodigo: null,
                           transaccionId: this.idTransaccion,
                           referencia: null,
                           autorizacion: null,
                           responseCode: null,
                           responseName: null,
                           maskPan: null,
                           seccion: null,
                           periodoDeCiclo: 0,
                           decanatoCodigo: null,
                           materiaCodigo: null,
                           cantidad: 1,
                           programaIdiomaId: this.selectPrograma,
                           nivel: this.idiomaNivel,
                           botonDePagoId: 2
                        })
                        .then((response) => {
                           if (response.status == 201) {
                              // Llamar a popup de pago de serfinsa
                              this.insertPagoRes = response.data
                              this.tokenSerfinsa = this.tokenIdiomas
                              setTimeout(() => {
                                 $('#btPagar').trigger('click')
                              }, 300)
                           } else {
                              this.showSnack(
                                 'El sistema no pudo inicializar su proceso de pago.',
                                 'snackError'
                              )
                           }
                        })
                        .catch((error) => {
                           this.dialogEsperaPago = false
                           console.log(error.response)
                           this.showSnack(
                              'No es posible registrar su intento de pago.',
                              'snackError'
                           )
                        })
                  }
               }
            })
            .catch(() => {
               this.dialogEsperaPago = false
               this.showSnack(
                  'Sistema en mantenimiento, intenta mas tarde',
                  'snackError'
               )
            })
      },
      // Muestra snack
      showSnack(text, color) {
         this.snackText = text
         this.snackColor = color
         this.snackbar = true
      },
      // Generar id para pruebas de transaccion
      makeid(length) {
         var result = ''
         var characters =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
         var charactersLength = characters.length
         for (var i = 0; i < length; i++) {
            result += characters.charAt(
               Math.floor(Math.random() * charactersLength)
            )
         }
         return result
      },
      // Imprimir una cuota
      imprimirCuota(item) {
         this.periodoLectivo = item.periodoLectivo
         this.cuotaFacturada = item.facturado
         this.fechaDePago = item.fechaDePago
         // Obteniendo info de talonario
         this.showSnack('Generando documento...', 'snackInfo')
         this.getInfoTalonario().then(() => {
            this.generarReporteTalonario(
               this.$vuetify.breakpoint.smAndUp ? 'open' : 'save',
               false,
               item.cuota.toString()
            )
         })
      },
      // Imprimir un arancel
      imprimirArancel(item) {
         this.totalPagar = item.precio
         this.periodoLectivo = item.periodoLectivo
         this.cuotaFacturada = item.facturado
         this.materiaCodigo =
            item.codigoMateria === undefined ? '' : item.codigoMateria
         this.materiaNombre = item.materia === undefined ? '' : item.materia
         this.fechaDePago = item.fechaDePago

         // Obtener npes y otros datos desde api
         axios
            .post('api/Pago/offline', {
               cliente: this.carnet,
               arancelCodigo: item.codigo
            })
            .then((response) => {
               //console.log(response)
               this.resImprimir = response.data
            })
            .catch(() => {
               //console.log(error)
            })
            .finally(() => {
               this.showSnack('Generando documento...', 'snackInfo')
               this.generarReporteArancel(
                  this.$vuetify.breakpoint.smAndUp ? 'open' : 'save'
               )
            })
      },
      // Imprimir comprobante de pago
      imprimirComprobantePago(res, timeout = 4500, mode = 'save', tipo) {
         return new Promise((resolve) => {
            this.detallesComprobantes = []
            //console.log(res)
            if (tipo == 'arancel') {
               // Para aranceles
               this.npe = ''
               this.fechaDePago = this.popupRes.Fecha
               this.autorizacion = this.popupRes.NumeroAutorizacion
               this.referencia = this.popupRes.NumeroReferencia
               this.detallePagoArancel = []

               var esGraduacion = res.find(
                  (el) =>
                     el.arancelCodigo == '01-020' ||
                     el.arancelCodigo == '02-062'
               )
               if (esGraduacion != undefined) {
                  res.forEach((el) => {
                     this.detallePagoArancel.push({
                        codigo: el.arancelCodigo,
                        itemCantidad: 1,
                        descripcion: el.arancel,
                        precioUnitario: Number(el.monto),
                        materiaCodigo: el.materiaCodigo
                     })
                  })
               } else {
                  this.detallePagoArancel.push({
                     codigo: res[0].arancelCodigo,
                     itemCantidad: this.itemCantidad,
                     descripcion: res[0].arancel,
                     precioUnitario: Number(res[0].monto),
                     materiaCodigo: this.materiaCodigo
                  })
               }
            } else {
               // Para cuotas
               res.forEach((el) => {
                  this.detallesComprobantes.push(el.npe)
               })
               this.fechaDePago = this.popupRes.Fecha
               this.autorizacion = this.popupRes.NumeroAutorizacion
               this.referencia = this.popupRes.NumeroReferencia
            }
            setTimeout(() => {
               this.generarComprobantePago(mode, tipo)
               resolve('ok')
            }, timeout)
         })
      },
      // Imprimir comprobante beca
      generarComprobanteBeca(mode, item) {
         this.showSnack(
            'Generando comprobante de beca, por favor espere...',
            'snackInfo'
         )

         console.log(item)

         var becasCuotas = []
         item.detalle.forEach((el) => {
            if (el.tipoBeca !== null) {
               becasCuotas.push(el)
            }
         })

         // Obtener lista de npes de pagos con beca
         var npesBecas = []
         item.detalle.forEach((el) => {
            if (el.tipoBeca != null) {
               npesBecas.push(el)
            }
         })

         // Consultando monto sin beca
         var descuentosCuotas = []
         axios
            .get(
               `api/contrato/cuotas?npes=${npesBecas
                  .map((e) => e.npe)
                  .join(',')}`
            )
            .then((response) => {
               response.data.forEach((el) => {
                  descuentosCuotas.push(el)
               })
            })
            .catch(() => {
               //console.log(error)
            })
            .finally(() => {
               const plantillaBecario = (data) => {
                  var res = []
                  var c = 0

                  data.forEach((detalle) => {
                     var cuotaDesc = descuentosCuotas.find(
                        (obj) => obj.npe == detalle.npe
                     )

                     var totalDescuento = Number(cuotaDesc.montoAplicaBeca)

                     var montoPart = this.toFixedRegex(totalDescuento, 2)
                        .toString()
                        .split('.')
                     c++
                     var tempRow = []
                     tempRow.push([
                        {
                           text:
                              '\n\n\nPOR: $' +
                              this.numFormatIntl(totalDescuento) +
                              '\n\n\n\n',
                           alignment: 'right'
                        }
                     ])

                     tempRow.push([
                        {
                           text: `RECIBÍ DE LA UNIVERSIDAD CATÓLICA DE EL SALVADOR LA CANTIDAD DE:
                        ${this.numeroLetras(montoPart[0])} ${
                              montoPart[1]
                           }/100 US DOLARES\n\n`,
                           alignment: 'justify'
                        }
                     ])

                     tempRow.push([
                        {
                           text: `EN CONCEPTO DE: ${detalle.tipoBeca.toUpperCase()}, EN PAGO DE CUOTA: ${
                              detalle.numeroCuota
                           }, EN CICLO: ${
                              detalle.periodoLectivo
                           }, PARA EL ALUMNO CON CARNET: ${
                              this.carnet
                           }, DE LA CARRERA DE: ${
                             this.nombreCarrera
                           }.\n\n`,
                           alignment: 'justify'
                        }
                     ])

                     tempRow.push([
                        {
                           text: `${
                              this.sede == 'SA' ? 'SANTA ANA' : 'ILOBASCO'
                           }, ${item.fecha.substr(0, 2)} DE ${this.obtenerMes(
                              this.parseDate(item.fecha.substr(0, 10))
                           ).toUpperCase()} DE ${item.fecha.substr(
                              6,
                              4
                           )}.\n\n\n\n\n\n\n\n`,
                           alignment: 'justify'
                        }
                     ])

                     tempRow.push([
                        {
                           table: {
                              widths: [10, '*'],
                              body: [
                                 [
                                    {
                                       text: 'F.',
                                       alignment: 'center',
                                       bold: true,
                                       border: [0, 0]
                                    },
                                    {
                                       text: '',
                                       alignment: 'center',
                                       bold: true,
                                       border: [0, 0, 0, 1]
                                    }
                                 ],
                                 [
                                    {
                                       text:
                                          item.nombre
                                             .trim()
                                             .replace(/  +/g, ' ') +
                                          '\n\n\n\n\n\n',
                                       alignment: 'center',
                                       colSpan: '2',
                                       border: [0, 0]
                                    },
                                    {}
                                 ]
                              ]
                           },
                           layout: '',
                           margin: [90, 0]
                        }
                     ])

                     tempRow.push([
                        {
                           table: {
                              widths: ['auto', '*'],
                              body: [
                                 [
                                    {
                                       text: 'NOMBRE:',
                                       bold: true,
                                       border: [1, 1, 0, 0]
                                    },
                                    {
                                       text:
                                          detalle.nombres.trim().toUpperCase() +
                                          ' ' +
                                          detalle.apellidos
                                             .trim()
                                             .toUpperCase(),
                                       border: [0, 1, 1, 0]
                                    }
                                 ],
                                 [
                                    {
                                       text: 'DUI:',
                                       bold: true,
                                       border: [1, 0, 0, 0]
                                    },
                                    {
                                       text: detalle.dui,
                                       border: [0, 0, 1, 0]
                                    }
                                 ],
                                 [
                                    {
                                       text: 'NIT:',
                                       bold: true,
                                       border: [1, 0, 0, 0]
                                    },
                                    {
                                       text: detalle.nit,
                                       border: [0, 0, 1, 0]
                                    }
                                 ],
                                 [
                                    {
                                       text: 'DIRECCIÓN:',
                                       bold: true,
                                       border: [1, 0, 0, 0]
                                    },
                                    {
                                       text: detalle.direccion,
                                       border: [0, 0, 1, 0]
                                    }
                                 ],
                                 [
                                    {
                                       text: 'EMAIL:',
                                       bold: true,
                                       border: [1, 0, 0, 1]
                                    },
                                    {
                                       text: detalle.email,
                                       border: [0, 0, 1, 1]
                                    }
                                 ]
                              ]
                           },
                           layout: '',
                           margin: [0, 0, 150, 0]
                        }
                     ])

                     tempRow.push([
                        {
                           table: {
                              widths: ['*', '*'],
                              body: [
                                 [
                                    {
                                       text: 'UNIVERSIDAD CATÓLICA DE EL SALVADOR BY PASS A METAPÁN Y CARRETERA ANTIGUA A SAN SALVADOR, SANTA ANA. TEL. 2484-0600',
                                       alignment: 'justify',
                                       bold: true,
                                       colSpan: 2
                                    },
                                    {}
                                 ],
                                 [
                                    {
                                       text: 'N.I.T. 0210-250682-001-7',
                                       alignment: 'center',
                                       bold: true
                                    },
                                    {
                                       text: 'N.R.C. 26024-0',
                                       alignment: 'center',
                                       bold: true
                                    }
                                 ]
                              ]
                           },
                           layout: '',
                           margin: [0, 20, 150, 0]
                        }
                     ])

                     var breakPage = c < data.length ? 'after' : ''
                     // DISEÑO DE TABLAR INTERNA
                     res.push({
                        table: {
                           headerRows: 0,
                           widths: ['*'],
                           body: tempRow
                        },
                        layout: 'noBorders',
                        margin: [0, 0],
                        pageBreak: breakPage
                     })
                  })
                  return res
               }

               var dd = {
                  // Tamaño de pagina
                  pageSize: 'LETTER',
                  pageOrientation: 'portrait',
                  pageMargins: [60, 20],
                  background: () => {
                     return {
                        image: this.selloCanceladoNoDate,
                        absolutePosition: {
                           x: 225,
                           y: 250
                        },
                        width: 170,
                        opacity: 0.3
                     }
                  },
                  watermark: {
                     text: 'CANCELADO',
                     color: 'red',
                     angle: 0,
                     fontSize: 60,
                     font: 'Roboto',
                     opacity: 0.3,
                     bold: true
                  },
                  content: [plantillaBecario(becasCuotas)],
                  defaultStyle: {
                     fontSize: 12,
                     font: 'TimesNewRoman'
                  }
               }

               var filename = `Comprobante Becario ${item.autorizacion} ${
                  item.alumnoCarnet
               } ${this.parseDate(item.fecha.substr(0, 10))}.pdf`
               getReporteLib().then((res) =>
                  res.generarPDF('save', dd, filename)
               )
            })
      },
      // Imprimir comprobante de pago
      reImprimirComprobantePago(item) {
         this.detallesComprobantes = []
         this.showSnack(
            'Generando comprobante de pago, por favor espere...',
            'snackInfo'
         )
         this.fechaDePago = item.fecha
         this.autorizacion = item.autorizacion
         this.referencia = item.referencia
         this.itemPrecio = Number(item.detalle[0].monto)
         this.materiaCodigo = item.detalle[0].materiaCodigo
         this.materiaNombre = ''
         this.itemCantidad =
            item.tipoPago.toLowerCase() == 'arancel' ? item.cantidad : 1
         this.totalPagar = Number(item.total)

         if (item.tipoPago.toLowerCase() == 'arancel') {
            // Para aranceles
            this.npe = ''
            this.detallePagoArancel = []

            this.idiomaNivel =
               item.detalle[0].nivel != '' ? item.detalle[0].nivel : ''
            this.idiomaProgramaDesc =
               item.detalle[0].programa != '' ? item.detalle[0].programa : ''
            this.idiomaNombre =
               item.detalle[0].idioma != '' ? item.detalle[0].idioma : ''

            var esGraduacion = item.detalle.find(
               (el) =>
                  el.arancelCodigo == '01-020' || el.arancelCodigo == '02-062'
            )
            if (esGraduacion != undefined) {
               item.detalle.forEach((el) => {
                  this.detallePagoArancel.push({
                     codigo: el.arancelCodigo,
                     itemCantidad: 1,
                     descripcion: el.arancel,
                     precioUnitario: Number(el.monto),
                     materiaCodigo: el.materiaCodigo
                  })
               })
            } else {
               this.detallePagoArancel.push({
                  codigo: item.detalle[0].arancelCodigo,
                  itemCantidad: this.itemCantidad,
                  descripcion: item.detalle[0].arancel,
                  precioUnitario: Number(item.detalle[0].monto),
                  materiaCodigo: this.materiaCodigo
               })
            }
         } else {
            // Para cuotas
            this.detallesPendientes = []
            this.detallesComprobantes = []
            item.detalle.forEach((el) => {
               this.detallesPendientes.push({
                  cuota: el.numeroCuota,
                  npe: el.npe,
                  periodoLectivo: el.periodoLectivo,
                  monto: Number(el.monto),
                  montoConDescuento: Number(el.monto),
                  descuentoPorBeca: el.descuento,
                  tipoBeca: el.tipoBeca,
                  recargo: 0
               })
               this.detallesComprobantes.push(el.npe)
            })
         }
         setTimeout(() => {
            this.generarComprobantePago('save', item.tipoPago.toLowerCase())
         }, 300)
      },
      // Obtiene variables de queryString
      getQueryVariables() {
         this.carnet = this.$route.query.carnet
         this.accesscode = this.$route.query.accesscode
         this.verificado = false
         this.loadingMessage = 'Verificando alumno...'
         this.alumnoMessage = ''

         // Limpiar sesión anterior para que cada acceso nuevo empiece limpio
         sessionStorage.removeItem('alumno_session_start')
         sessionStorage.removeItem('alumno_session_expired')

         // Consultar estado del sistema antes de verificar al alumno
         // para mostrar el mensaje de mantenimiento en la pantalla de carga
         this.obtenerEstadoSistema()

         // Capturar fecha y hora exacta de inicio de verificación
         this.loadingFechaHora = new Date().toLocaleString('es-SV', {
            dateStyle: 'full',
            timeStyle: 'medium'
         })

         // Arrancar contador visual de carga
         this.loadingSegundos = 0
         if (this.loadingContadorHandle) clearInterval(this.loadingContadorHandle)
         this.loadingContadorHandle = setInterval(() => {
            this.loadingSegundos++
         }, 1000)

         // Revisar identidad del alumno
         const t0ValidarAlumno = performance.now()
         axios
            .get(
               'api/ValidarAlumno?Carnet=' +
                  this.carnet +
                  '&AccessCode=' +
                  this.accesscode
            )
            .then((response) => {
               const msTotal = Math.round(performance.now() - t0ValidarAlumno)
               const msBackend = response.headers['x-timing'] || 'n/d'
               console.info(`[PERF] ValidarAlumno | Frontend total: ${msTotal}ms | Backend: ${msBackend}`)
               const tiempoTranscurrido = performance.now() - t0ValidarAlumno
               const tiempoRestante = Math.max(0, 5000 - tiempoTranscurrido)
               setTimeout(() => {
                  clearInterval(this.loadingContadorHandle)
                  this.loadingContadorHandle = null
                  if (response.data[0] !== undefined) {
                     this.verificado = true
                     this.alumnoMessage = 'Bienvenido/a, '
                     this.obtenerEstadoSistema()
                     this.listarComboboxes()
                     this.listarCuotasPendientes()
                  } else {
                     this.loadingMessage = 'Datos incorrectos'
                     this.verificado = false
                  }
               }, tiempoRestante)
            })
            .catch(() => {
               clearInterval(this.loadingContadorHandle)
               this.loadingContadorHandle = null
            })
      },
      // Autoseleccionar la busqueda al cambiar filtro de busquedad
      focusBusqueda() {
         this.$refs.txtBusqueda.focus()
      },
      // Genera reporte de cuota
      generarReporteTalonario(mode, portadas = true, filtroCuotas = null) {
         var filteredDetalles = []

         // Filtrando cuotas si es solicitado
         if (filtroCuotas) {
            var res = filtroCuotas.split(',').map((item) => {
               return item.trim()
            })
            filteredDetalles = this.talonario.contratoPlanPagos.filter((el) =>
               res.includes(el.cuota.toString())
            )
            filteredDetalles =
               filteredDetalles.length == 0
                  ? this.talonario.contratoPlanPagos
                  : filteredDetalles
         } else {
            filteredDetalles = this.talonario.contratoPlanPagos
         }

         const getDetalleAranceles = (cuota) => {
            var result = []
            this.pagoExtemporaneo = Number(cuota.monto) + 12
            var fS = this.aranceles.length < 5 ? 8 : 7
            // Excepción únicamente para: DOCTORADO EN MEDICINA / FACULTAD DE CIENCIAS DE LA SALUD
            const esDoctoradoMedSalud =
            (this.talonario?.gradoAcademico || '').trim().toUpperCase() ===
            'DOCTORADO EN MEDICINA' &&
            (this.talonario?.unidadEducativa || '').trim().toUpperCase() ===
            'FACULTAD DE CIENCIAS DE LA SALUD'



            this.aranceles.forEach((arancel) => {
               // Imprimiendo aranceles (U)nicos solo en primera cuota
               if (
                  arancel.tipoCobro == 'U' &&
                  cuota.cuota == 1 &&
                  !arancel.extraordinaria &&
                  !arancel.procesoGraduacion &&
                  (!this.talonario.procesoGraduacion || esDoctoradoMedSalud)
               ) {
                  result.push([
                     {
                        text: arancel.articulo,
                        alignment: 'right',
                        fontSize: fS
                     },
                     {
                        text: arancel.descripcion.replace('_', ' '),
                        fontSize: fS
                     },
                     { text: '$', fontSize: fS },
                     {
                        text: this.toFixedRegex(
                           Number(arancel.precioUnitario) +
                              Number(arancel.montoImpuesto),
                           2
                        ),
                        fontSize: fS,
                        margin: [0, 0, 35, 0],
                        alignment: 'right'
                     }
                  ])
               }

               // Impriendo aranceles (R)ecurrentes en todas las cuotas
               if (
                  arancel.tipoCobro == 'R' &&
                  !arancel.extraordinaria &&
                  !arancel.procesoGraduacion &&
                  !this.talonario.procesoGraduacion
               ) {
                  result.push([
                     {
                        text: arancel.articulo,
                        alignment: 'right',
                        fontSize: fS
                     },
                     {
                        text: arancel.descripcion.replace('_', ' '),
                        fontSize: fS
                     },
                     { text: '$', fontSize: fS },
                     {
                        text: this.toFixedRegex(
                           Number(arancel.precioUnitario) +
                              Number(arancel.montoImpuesto),
                           2
                        ),
                        fontSize: fS,
                        margin: [0, 0, 35, 0],
                        alignment: 'right'
                     }
                  ])
               }

               // Impriendo arancel de proceso gracuadion si el talonario esta en proceso de graduacion
               if (
                  arancel.tipoCobro == 'R' &&
                  !arancel.extraordinaria &&
                  arancel.procesoGraduacion &&
                  this.talonario.procesoGraduacion
               ) {
                  result.push([
                     {
                        text: arancel.articulo,
                        alignment: 'right',
                        fontSize: fS
                     },
                     {
                        text: arancel.descripcion.replace('_', ' '),
                        fontSize: fS
                     },
                     { text: '$', fontSize: fS },
                     {
                        text: this.toFixedRegex(
                           Number(arancel.precioUnitario) +
                              Number(arancel.montoImpuesto),
                           2
                        ),
                        fontSize: fS,
                        margin: [0, 0, 35, 0],
                        alignment: 'right'
                     }
                  ])
               }
            })
            result.push([
               {
                  text: 'TOTAL A PAGAR',
                  fontSize: 10,
                  margin: [0, 0, 15, 0],
                  bold: true,
                  alignment: 'right',
                  colSpan: 2
               },
               {},
               {
                  text: '$',
                  fontSize: 10,
                  bold: true
               },
               {
                  text: cuota.monto,
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0, 35, 0],
                  alignment: 'right'
               }
            ])
            return result
         }

         const getTalonarioBody = (showPortadas) => {
            var resultPage = []

            // ------------------------------------ PORTADA ----------------------------------------
            if (showPortadas) {
               resultPage.push([
                  {
                     table: {
                        widths: ['*', 120, '*'],
                        body: [
                           [
                              {
                                 text: 'UNIVERSIDAD CATÓLICA DE EL SALVADOR',
                                 font: 'TimesNewRoman',
                                 fontSize: 20,
                                 bold: true,
                                 alignment: 'center',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: '_',
                                 color: 'white',
                                 fontSize: 20,
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: 'NUESTRA MISIÓN',
                                 bold: true,
                                 italics: true,
                                 alignment: 'center',
                                 decoration: 'underline'
                              },
                              {
                                 image: this.logo64,
                                 alignment: 'center',
                                 rowSpan: 2,
                                 width: 90
                              },
                              {
                                 text: 'NUESTRA VISIÓN',
                                 bold: true,
                                 italics: true,
                                 alignment: 'center',
                                 decoration: 'underline'
                              }
                           ],
                           [
                              {
                                 text:
                                    'La formación de personas, inspirada en los principios cristianos y en los conocimientos' +
                                    ' técnicos y científicos, orientada a una constante búsqueda de la verdad y del uso del saber,' +
                                    ' para contribuir a la tutela y desarrollo de la dignidad humana y de la sociedad,' +
                                    ' mediante la investigación, docencia y la proyección social.',
                                 alignment: 'justify'
                              },
                              {},
                              {
                                 text:
                                    'Seremos una universidad con excelentes servicios de educación superior, líderes en la' +
                                    ' formación integral de la persona humana y de la sociedad, dentro de las' +
                                    ' exigencias de la verdad y del bien común.',
                                 alignment: 'justify'
                              }
                           ],
                           [
                              {
                                 text: '_',
                                 color: 'white',
                                 fontSize: 20,
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 table: {
                                    widths: [150, 60, '*', 90],
                                    body: [
                                       [
                                          {},
                                          {
                                             text: 'CARNET:',
                                             bold: true
                                          },
                                          {
                                             text: this.talonario.cliente
                                          },
                                          {
                                             image: this.cda64,
                                             alignment: 'center',
                                             rowSpan: 4,
                                             width: 90
                                          }
                                       ],
                                       [
                                          {},
                                          {
                                             text: 'NOMBRE:',
                                             bold: true
                                          },
                                          {
                                             text: this.talonario.nombre
                                          },
                                          {}
                                       ],
                                       [
                                          {},
                                          {
                                             text: 'FACULTAD:',
                                             bold: true
                                          },
                                          {
                                             text: this.talonario
                                                .unidadEducativa
                                          },
                                          {}
                                       ],
                                       [
                                          {},
                                          {
                                             text: 'CARRERA:',
                                             bold: true
                                          },
                                          {
                                             text: this.talonario.gradoAcademico
                                          },
                                          {}
                                       ]
                                    ]
                                 },
                                 layout: 'noBorders',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: '_',
                                 color: 'white',
                                 fontSize: 16,
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text:
                                    'TALONARIO UNICAMENTE PARA CICLO: ' +
                                    this.talonario.periodoLectivo,
                                 alignment: 'center',
                                 fontSize: '20',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text:
                                    'Talonario No. ' +
                                    this.talonario.codigoTalonario,
                                 fontSize: 10,
                                 alignment: 'right',
                                 bold: true,
                                 colSpan: 3
                              },
                              {},
                              {}
                           ]
                        ]
                     },
                     layout: 'noBorders',
                     colSpan: 2
                  },
                  {}
               ])
            }

            // ------------------------------------ CUOTAS ----------------------------------------
            filteredDetalles.forEach((cuota) => {
               resultPage.push([
                  [
                     {
                        table: {
                           widths: [45, '*', '*'],
                           body: [
                              [
                                 {
                                    text: 'UNIVERSIDAD CATÓLICA\nDE EL SALVADOR',
                                    font: 'TimesNewRoman',
                                    fontSize: 10,
                                    bold: true,
                                    alignment: 'center',
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 'CARNET:',
                                 {
                                    text: this.talonario.cliente,
                                    colSpan: 2
                                 },
                                 {}
                              ],
                              [
                                 'ALUMNO:',
                                 {
                                    text: this.talonario.nombre,
                                    colSpan: 2
                                 },
                                 {}
                              ],
                              [
                                 'CARRERA:',
                                 {
                                    text: this.talonario.gradoAcademico,
                                    colSpan: 2
                                 },
                                 {}
                              ],
                              [
                                 'CICLO:',
                                 { text: this.talonario.periodoLectivo },
                                 {
                                    text: [
                                       { text: 'Pago N° ' },
                                       {
                                          text: cuota.cuota,
                                          fontSize: 18,
                                          bold: true
                                       }
                                    ]
                                 }
                              ],
                              [
                                 {
         text:
   (() => {
      const nombre = (this.talonario.gradoAcademico || '')
         .trim()
         .toUpperCase()

      const esPosgrado = this.listaPosgrados.has(nombre)

      return esPosgrado
         ? 'ESCUELA DE POSGRADOS'
         : 'FACULTAD:\n' + (this.talonario.unidadEducativa || '')
   })(),
bold: true,
alignment: 'center',
colSpan: 3

                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    table: {
                                       widths: [60, 120, 5, '*'],
                                       body: getDetalleAranceles(cuota)
                                    },
                                    layout: 'noBorders',
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    text: '_',
                                    color: 'white',
                                    fontSize: 6,
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    table: {
                                       widths: [15, 150, 110],
                                       body: [
                                          [
                                             {},
                                             {
                                                text: 'FECHA VENCIMIENTO',
                                                fontSize: 10,
                                                bold: true
                                             },
                                             {
                                                text: cuota.fechaVencimiento,
                                                fontSize: 10,
                                                bold: true,
                                                margin: [0, 0, 45, 0],
                                                alignment: 'right'
                                             }
                                          ],
                                          [
                                             {},
                                             {
                                                text: 'PAGO EXTEMPORANEO',
                                                fontSize: 10,
                                                bold: true
                                             },
                                             {
                                                text: this.toFixedRegex(
                                                   this.pagoExtemporaneo,
                                                   2
                                                ),
                                                fontSize: 10,
                                                bold: true,
                                                margin: [0, 0, 45, 0],
                                                alignment: 'right'
                                             }
                                          ]
                                       ]
                                    },
                                    layout: 'noBorders',
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    text: 'NPE',
                                    fontSize: 9,
                                    bold: true,
                                    alignment: 'right'
                                 },
                                 {
                                    text: cuota.npe,
                                    fontSize: 9,
                                    bold: true,
                                    colSpan: 2
                                 },
                                 {}
                              ],
                              [
                                 {
                                    text: Base64.decode(
                                       cuota.codigoDeBarrasCode128C
                                    ),
                                    font: 'CodigoDeBarra',
                                    colSpan: 3,
                                    fontSize: 10,
                                    alignment: 'center'
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    text: cuota.codigoDeBarras,
                                    alignment: 'center',
                                    fontSize: 7,
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    text:
                                       'Talonario No. ' +
                                       this.talonario.codigoTalonario,
                                    bold: true,
                                    alignment: 'center',
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    text: 'ALUMNO',
                                    bold: true,
                                    alignment: 'center',
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              // SELLO CANCELADO
                              [
                                 {
                                    image: this.cuotaFacturada
                                       ? this.selloCancelado
                                       : this.emptyImage,
                                    absolutePosition: {
                                       x: 72,
                                       y: cuota.cuota == 1 ? 258 : 212
                                    },
                                    width: 170
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    text: this.cuotaFacturada
                                       ? this.fechaDePago.substr(0, 10)
                                       : '',
                                    bold: true,
                                    color: '#d9001d',
                                    fontSize: 14,
                                    absolutePosition: {
                                       x:
                                          this.fechaDePago == 'PAGO BANCO'
                                             ? 114
                                             : 120,
                                       y: cuota.cuota == 1 ? 312 : 266
                                    }
                                 },
                                 {},
                                 {}
                              ]
                           ]
                        },
                        margin: [0, 0, 15, 0],
                        layout: 'noBorders'
                     }
                  ],
                  [
                     {
                        table: {
                           widths: [45, '*', '*'],
                           body: [
                              [
                                 {
                                    text: 'UNIVERSIDAD CATÓLICA\nDE EL SALVADOR',
                                    font: 'TimesNewRoman',
                                    fontSize: 10,
                                    bold: true,
                                    alignment: 'center',
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 'CARNET:',
                                 {
                                    text: this.talonario.cliente,
                                    colSpan: 2
                                 },
                                 {}
                              ],
                              [
                                 'ALUMNO:',
                                 {
                                    text: this.talonario.nombre,
                                    colSpan: 2
                                 },
                                 {}
                              ],
                              [
                                 'CARRERA:',
                                 {
                                    text: this.talonario.gradoAcademico,
                                    colSpan: 2
                                 },
                                 {}
                              ],
                              [
                                 'CICLO:',
                                 { text: this.talonario.periodoLectivo },
                                 {
                                    text: [
                                       { text: 'Pago N° ' },
                                       {
                                          text: cuota.cuota,
                                          fontSize: 18,
                                          bold: true
                                       }
                                    ]
                                 }
                              ],
                              [
                                 {
                                    text:
   (() => {
      const nombre = (this.talonario.gradoAcademico || '')
         .trim()
         .toUpperCase()

      const esPosgrado = this.listaPosgrados.has(nombre)

      return esPosgrado
         ? 'ESCUELA DE POSGRADOS'
         : 'FACULTAD:\n' + (this.talonario.unidadEducativa || '')
   })(),
bold: true,
alignment: 'center',
colSpan: 3

                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    table: {
                                       widths: [60, 120, 5, '*'],
                                       body: getDetalleAranceles(cuota)
                                    },
                                    layout: 'noBorders',
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    text: '_',
                                    color: 'white',
                                    fontSize: 6,
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    table: {
                                       widths: [15, 150, 110],
                                       body: [
                                          [
                                             {},
                                             {
                                                text: 'FECHA VENCIMIENTO',
                                                fontSize: 10,
                                                bold: true
                                             },
                                             {
                                                text: cuota.fechaVencimiento,
                                                fontSize: 10,
                                                bold: true,
                                                margin: [0, 0, 45, 0],
                                                alignment: 'right'
                                             }
                                          ],
                                          [
                                             {},
                                             {
                                                text: 'PAGO EXTEMPORANEO',
                                                fontSize: 10,
                                                bold: true
                                             },
                                             {
                                                text: this.toFixedRegex(
                                                   this.pagoExtemporaneo,
                                                   2
                                                ),
                                                fontSize: 10,
                                                bold: true,
                                                margin: [0, 0, 45, 0],
                                                alignment: 'right'
                                             }
                                          ]
                                       ]
                                    },
                                    layout: 'noBorders',
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    text: 'NPE',
                                    fontSize: 9,
                                    bold: true,
                                    alignment: 'right'
                                 },
                                 {
                                    text: cuota.npe,
                                    fontSize: 9,
                                    bold: true,
                                    colSpan: 2
                                 },
                                 {}
                              ],
                              [
                                 {
                                    text: Base64.decode(
                                       cuota.codigoDeBarrasCode128C
                                    ),
                                    font: 'CodigoDeBarra',
                                    colSpan: 3,
                                    fontSize: 10,
                                    alignment: 'center'
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    text: cuota.codigoDeBarras,
                                    alignment: 'center',
                                    fontSize: 7,
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    text:
                                       'Talonario No. ' +
                                       this.talonario.codigoTalonario,
                                    bold: true,
                                    alignment: 'center',
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    text: 'UNIVERSIDAD',
                                    bold: true,
                                    alignment: 'center',
                                    colSpan: 3
                                 },
                                 {},
                                 {}
                              ],
                              // SELLO CANCELADO
                              [
                                 {
                                    image: this.cuotaFacturada
                                       ? this.selloCancelado
                                       : this.emptyImage,
                                    absolutePosition: {
                                       x: 302 + 72,
                                       y: cuota.cuota == 1 ? 258 : 212
                                    },
                                    width: 170
                                 },
                                 {},
                                 {}
                              ],
                              [
                                 {
                                    text: this.cuotaFacturada
                                       ? this.fechaDePago.substr(0, 10)
                                       : '',
                                    bold: true,
                                    color: '#d9001d',
                                    fontSize: 14,
                                    absolutePosition: {
                                       x:
                                          this.fechaDePago == 'PAGO BANCO'
                                             ? 302 + 114
                                             : 302 + 120,
                                       y: cuota.cuota == 1 ? 312 : 266
                                    }
                                 },
                                 {},
                                 {}
                              ]
                           ]
                        },
                        margin: [15, 0, 0, 0],
                        layout: 'noBorders'
                     }
                  ]
               ])
            })

            // ------------------------------------ REVERSO ----------------------------------------
            if (showPortadas) {
               resultPage.push([
                  {
                     table: {
                        widths: ['*', 175, '*'],
                        body: [
                           [
                              {
                                 text: 'TALONARIO DE PAGOS',
                                 font: 'TimesNewRoman',
                                 fontSize: 20,
                                 bold: true,
                                 alignment: 'center',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: '_',
                                 color: 'white',
                                 fontSize: 20,
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: 'INSTRUCCIONES',
                                 bold: true,
                                 italics: true,
                                 alignment: 'center',
                                 decoration: 'underline'
                              },
                              {
                                 image: this.logo64,
                                 alignment: 'center',
                                 width: 90,
                                 rowSpan: 2
                              },
                              {
                                 text: 'RECUERDE QUE',
                                 bold: true,
                                 italics: true,
                                 alignment: 'center',
                                 decoration: 'underline'
                              }
                           ],
                           [
                              {
                                 text:
                                    '1.    Los pagos deberán ser cancelados en el Banco que la Universidad autorice para realizar' +
                                    ' los cobros de los alumnos.',
                                 alignment: 'justify'
                              },
                              {},
                              {
                                 text:
                                    '1.    El vencimiento de las cuotas está programado en su talonario de pago y en el calendario' +
                                    ' académico. (Art. 29 del reglamento de evaluación).',
                                 alignment: 'justify'
                              }
                           ],
                           [
                              {
                                 text:
                                    '2.    Es responsabilidad del alumno verificar que el cajero firme y selle los recibos' +
                                    ' correspondiente a los pagos que realice en el Banco',
                                 alignment: 'justify'
                              },
                              {
                                 text: 'UNIVERSIDAD CATÓLICA DE EL SALVADOR',
                                 font: 'TimesNewRoman',
                                 bold: true,
                                 alignment: 'center',
                                 fontSize: 13
                              },
                              {
                                 text:
                                    '2.    Las matriculas y las cuotas canceladas en fechas posteriores a el vencimiento tendrán' +
                                    ' complemento de $12.00 y $12.00 respectivamente dicha medida será aplicada por el Banco automáticamente.',
                                 alignment: 'justify'
                              }
                           ],
                           [
                              {
                                 text:
                                    '\n3.    En caso de extravío del talonario de pagos deberá de solicitar una reposición' +
                                    ' en la colecturía de la Universidad, previo a pago respectivo.',
                                 alignment: 'justify'
                              },
                              {
                                 text:
                                    'By pass a Metapán y Carretera antigua a San Salvador\n' +
                                    'PBX: (503) 2484-0600\nFax: (503) 2441-2655,\nSanta Ana, El Salvador\n' +
                                    'Web: http://www.catolica.edu.sv\nE-mail: catolica@catolica.edu.sv',
                                 alignment: 'center',
                                 bold: true,
                                 fontSize: 11
                              },
                              { text: '', alignment: 'justify' }
                           ],
                           [
                              {
                                 text: '_',
                                 color: 'white',
                                 fontSize: 20,
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text:
                                    'Talonario No. ' +
                                    this.talonario.codigoTalonario,
                                 fontSize: 10,
                                 alignment: 'right',
                                 bold: true,
                                 colSpan: 3
                              },
                              {},
                              {}
                           ]
                        ]
                     },
                     layout: 'noBorders',
                     pageBreak: 'before',
                     colSpan: 2
                  },
                  {}
               ])
            }

            return resultPage
         }

         var dd = {
            pageSize: {
               width: 612.0,
               height: 396.0
            },
            background: function () {
               return {
                  canvas: [
                     {
                        // COLOR DE PAGINA
                        type: 'rect',
                        x: 0,
                        y: 0,
                        w: 612.0,
                        h: 396.0,
                        color: '#FFF'
                     }
                  ]
               }
            },
            pageMargins: [20, 10],
            content: [
               {
                  table: {
                     heights: 390.0,
                     widths: ['*', '*'],
                     body: getTalonarioBody(portadas)
                  },
                  layout: {
                     hLineWidth: function () {
                        return 0
                     },
                     vLineWidth: function (i) {
                        return i === 1 ? 1 : 0
                     },
                     vLineColor: function () {
                        return 'gray'
                     },
                     vLineStyle: function () {
                        return { dash: { length: 6 } }
                     }
                  }
               }
            ],
            defaultStyle: {
               fontSize: 9
            }
         }

         var filename = `Cuota ${filtroCuotas} Ciclo ${this.talonario.periodoLectivo} ${this.talonario.cliente}.pdf`
         getReporteLib().then((res) => res.generarPDF(mode, dd, filename))
      },
      // Genera reporte de arancel
      generarReporteArancel(mode) {
         const getArancelBody = () => {
            var resultPage = []

            resultPage.push([
               [
                  {
                     table: {
                        widths: [45, '*', '*'],
                        body: [
                           [
                              {
                                 text: 'UNIVERSIDAD CATÓLICA\nDE EL SALVADOR',
                                 font: 'TimesNewRoman',
                                 fontSize: 10,
                                 bold: true,
                                 alignment: 'center',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              'CARNET:',
                              {
                                 text: this.carnet,
                                 colSpan: 2
                              },
                              {}
                           ],
                           [
                              'ALUMNO:',
                              {
                                 text: this.alumno,
                                 colSpan: 2
                              },
                              {}
                           ],
                           [
                              'CARRERA:',
                              {
                                 text: this.nombreCarrera,
                                 colSpan: 2
                              },
                              {}
                           ],
                           [
                              'CICLO:',
                              {
                                 text: this.obtenerStrCiclo()
                              },
                              {}
                           ],
                           [
                              {
text:
   (() => {
      const carrera = this.cmbCarrera.find(
         obj => obj.codigo == this.selectCarrera
      )

      const nombre = (carrera?.nombre || '')
         .trim()
         .toUpperCase()

      const esPosgrado = this.listaPosgrados.has(nombre)

      return esPosgrado
         ? 'ESCUELA DE POSGRADOS'
         : 'FACULTAD:\n' + (carrera?.unidadAcademica || '')
   })(),
bold: true,
alignment: 'center',
colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: '_',
                                 color: 'white',
                                 fontSize: 6,
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: 'MANDAMIENTO DE PAGO DE ARANCELES',
                                 bold: true,
                                 fontSize: 10,
                                 alignment: 'center',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 table: {
                                    widths: [60, 120, 5, '*'],
                                    body: [
                                       [
                                          {
                                             text: this.resImprimir
                                                .codigoArancel,
                                             alignment: 'right',
                                             fontSize: 8
                                          },
                                          {
                                             text:
                                                this.resImprimir.arancel +
                                                (this.materiaCodigo != ''
                                                   ? ' ' + this.materiaCodigo
                                                   : ''),
                                             fontSize: 8
                                          },
                                          { text: '$', fontSize: 8 },
                                          {
                                             text: this.toFixedRegex(
                                                this.resImprimir.monto,
                                                2
                                             ),
                                             fontSize: 8,
                                             margin: [0, 0, 35, 0],
                                             alignment: 'right'
                                          }
                                       ],
                                       [
                                          {
                                             text: 'TOTAL A PAGAR',
                                             fontSize: 10,
                                             margin: [0, 0, 15, 0],
                                             bold: true,
                                             alignment: 'right',
                                             colSpan: 2
                                          },
                                          {},
                                          {
                                             text: '$',
                                             fontSize: 10,
                                             bold: true
                                          },
                                          {
                                             text: this.totalPagar,
                                             fontSize: 10,
                                             bold: true,
                                             margin: [0, 0, 35, 0],
                                             alignment: 'right'
                                          }
                                       ]
                                    ]
                                 },
                                 layout: 'noBorders',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: [
                                    {
                                       text:
                                          this.materiaCodigo != ''
                                             ? this.materiaCodigo + ': '
                                             : '',
                                       bold: true
                                    },
                                    this.materiaCodigo != ''
                                       ? this.materiaNombre
                                       : ''
                                 ],
                                 fontSize: this.materiaCodigo != '' ? 8 : 1,
                                 align: 'justify',
                                 margin: [20, 0],
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: '_',
                                 color: 'white',
                                 fontSize: 3,
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 table: {
                                    widths: [15, 150, 110],
                                    body: [
                                       [
                                          {},
                                          {
                                             text: 'VALIDO HASTA',
                                             fontSize: 10,
                                             bold: true
                                          },
                                          {
                                             text: this.formatDate(
                                                this.resImprimir.fechaVencimiento.substr(
                                                   0,
                                                   10
                                                )
                                             ),
                                             fontSize: 10,
                                             bold: true,
                                             margin: [0, 0, 45, 0],
                                             alignment: 'right'
                                          }
                                       ]
                                    ]
                                 },
                                 layout: 'noBorders',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: 'AVISO',
                                 fontSize: 9,
                                 bold: true,
                                 alignment: 'right'
                              },
                              {
                                 text: this.resImprimir.npe,
                                 alignment: 'justify',
                                 fontSize: 9,
                                 bold: true,
                                 colSpan: 2
                              },
                              {}
                           ],
                           [
                              {
                                 text: Base64.decode(
                                    this.resImprimir.barcodeEncoder
                                 ),
                                 font: 'CodigoDeBarra',
                                 colSpan: 3,
                                 fontSize: 10,
                                 alignment: 'center'
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: this.resImprimir.barcode,
                                 alignment: 'center',
                                 fontSize: 7,
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: 'El presente mandamiento, servirá únicamente para cancelar en Colecturía, UNICAES. Y no sustituye facturas o comprobantes de crédito fiscal.',
                                 bold: true,
                                 alignment: 'justify',
                                 colSpan: 3,
                                 margin: [13, 5]
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: 'ALUMNO',
                                 bold: true,
                                 alignment: 'center',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ]
                        ]
                     },
                     margin: [0, 0, 15, 0],
                     layout: 'noBorders'
                  }
               ],
               [
                  {
                     table: {
                        widths: [45, '*', '*'],
                        body: [
                           [
                              {
                                 text: 'UNIVERSIDAD CATÓLICA\nDE EL SALVADOR',
                                 font: 'TimesNewRoman',
                                 fontSize: 10,
                                 bold: true,
                                 alignment: 'center',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              'CARNET:',
                              {
                                 text: this.carnet,
                                 colSpan: 2
                              },
                              {}
                           ],
                           [
                              'ALUMNO:',
                              {
                                 text: this.alumno,
                                 colSpan: 2
                              },
                              {}
                           ],
                           [
                              'CARRERA:',
                              {
                                text: this.nombreCarrera,
                                 colSpan: 2
                              },
                              {}
                           ],
                           [
                              'CICLO:',
                              {
                                 text: this.obtenerStrCiclo()
                              },
                              {}
                           ],
                           [
                              {
                                 text:
   (() => {
      const carrera = this.cmbCarrera.find(
         obj => obj.codigo == this.selectCarrera
      )

      const nombre = (carrera?.nombre || '')
         .trim()
         .toUpperCase()

      const esPosgrado = this.listaPosgrados.has(nombre)

      return esPosgrado
         ? 'ESCUELA DE POSGRADOS'
         : 'FACULTAD:\n' + (carrera?.unidadAcademica || '')
   })(),
bold: true,
alignment: 'center',
colSpan: 3


                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: '_',
                                 color: 'white',
                                 fontSize: 6,
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: 'MANDAMIENTO DE PAGO DE ARANCELES',
                                 bold: true,
                                 fontSize: 10,
                                 alignment: 'center',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 table: {
                                    widths: [60, 120, 5, '*'],
                                    body: [
                                       [
                                          {
                                             text: this.resImprimir
                                                .codigoArancel,
                                             alignment: 'right',
                                             fontSize: 8
                                          },
                                          {
                                             text:
                                                this.resImprimir.arancel +
                                                (this.materiaCodigo != ''
                                                   ? ' ' + this.materiaCodigo
                                                   : ''),
                                             fontSize: 8
                                          },
                                          { text: '$', fontSize: 8 },
                                          {
                                             text: this.toFixedRegex(
                                                this.resImprimir.monto,
                                                2
                                             ),
                                             fontSize: 8,
                                             margin: [0, 0, 35, 0],
                                             alignment: 'right'
                                          }
                                       ],
                                       [
                                          {
                                             text: 'TOTAL A PAGAR',
                                             fontSize: 10,
                                             margin: [0, 0, 15, 0],
                                             bold: true,
                                             alignment: 'right',
                                             colSpan: 2
                                          },
                                          {},
                                          {
                                             text: '$',
                                             fontSize: 10,
                                             bold: true
                                          },
                                          {
                                             text: this.totalPagar,
                                             fontSize: 10,
                                             bold: true,
                                             margin: [0, 0, 35, 0],
                                             alignment: 'right'
                                          }
                                       ]
                                    ]
                                 },
                                 layout: 'noBorders',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: [
                                    {
                                       text:
                                          this.materiaCodigo != ''
                                             ? this.materiaCodigo + ': '
                                             : '',
                                       bold: true
                                    },
                                    this.materiaCodigo != ''
                                       ? this.materiaNombre
                                       : ''
                                 ],
                                 fontSize: this.materiaCodigo != '' ? 8 : 1,
                                 align: 'justify',
                                 margin: [20, 0],
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: '_',
                                 color: 'white',
                                 fontSize: 3,
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 table: {
                                    widths: [15, 150, 110],
                                    body: [
                                       [
                                          {},
                                          {
                                             text: 'VALIDO HASTA',
                                             fontSize: 10,
                                             bold: true
                                          },
                                          {
                                             text: this.formatDate(
                                                this.resImprimir.fechaVencimiento.substr(
                                                   0,
                                                   10
                                                )
                                             ),
                                             fontSize: 10,
                                             bold: true,
                                             margin: [0, 0, 45, 0],
                                             alignment: 'right'
                                          }
                                       ]
                                    ]
                                 },
                                 layout: 'noBorders',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: 'AVISO',
                                 fontSize: 9,
                                 bold: true,
                                 alignment: 'right'
                              },
                              {
                                 text: this.resImprimir.npe,
                                 alignment: 'justify',
                                 fontSize: 9,
                                 bold: true,
                                 colSpan: 2
                              },
                              {}
                           ],
                           [
                              {
                                 text: Base64.decode(
                                    this.resImprimir.barcodeEncoder
                                 ),
                                 font: 'CodigoDeBarra',
                                 colSpan: 3,
                                 fontSize: 10,
                                 alignment: 'center'
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: this.resImprimir.barcode,
                                 alignment: 'center',
                                 fontSize: 7,
                                 colSpan: 3
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: 'El presente mandamiento, servirá únicamente para cancelar en Colecturía, UNICAES. Y no sustituye facturas o comprobantes de crédito fiscal.',
                                 bold: true,
                                 alignment: 'justify',
                                 colSpan: 3,
                                 margin: [13, 5]
                              },
                              {},
                              {}
                           ],
                           [
                              {
                                 text: 'UNIVERSIDAD',
                                 bold: true,
                                 alignment: 'center',
                                 colSpan: 3
                              },
                              {},
                              {}
                           ]
                        ]
                     },
                     margin: [15, 0, 0, 0],
                     layout: 'noBorders'
                  }
               ]
            ])

            return resultPage
         }

         var dd = {
            pageSize: {
               width: 612.0,
               height: 396.0
            },
            background: () => {
               return {
                  canvas: [
                     {
                        // COLOR DE PAGINA
                        type: 'rect',
                        x: 0,
                        y: 0,
                        w: 612.0,
                        h: 396.0,
                        color: '#FFF'
                     }
                  ]
               }
            },
            pageMargins: [20, 10],
            content: [
               {
                  table: {
                     heights: 390.0,
                     widths: ['*', '*'],
                     body: getArancelBody()
                  },
                  layout: {
                     hLineWidth: function () {
                        return 0
                     },
                     vLineWidth: function (i) {
                        return i === 1 ? 1 : 0
                     },
                     vLineColor: function () {
                        return 'gray'
                     },
                     vLineStyle: function () {
                        return { dash: { length: 6 } }
                     }
                  }
               }
            ],
            defaultStyle: {
               fontSize: 9
            }
         }

         var filename = `Mandamiento Pago Arancel ${this.resImprimir.codigoArancel} ${this.carnet}.pdf`
         getReporteLib().then((res) => res.generarPDF(mode, dd, filename))
      },
      // Genera comprobante de pago
      generarComprobantePago(mode, tipo) {
         var pageHeight = 396.0
         if (
            this.detallesComprobantes.length > 4 ||
            this.detallePagoArancel.length > 4
         ) {
            pageHeight = 460.0
         }

         //console.log(me.detallePagoArancel)

         const getDetalleAranceles = () => {
            var result = []
            var fS = this.aranceles.length < 5 ? 8 : 7
            result.push([
               {
                  text: 'CODIGO',
                  alignment: 'right',
                  bold: true,
                  fontSize: fS
               },
               {
                  text: 'CANT.',
                  alignment: 'right',
                  bold: true,
                  fontSize: fS
               },
               {
                  text: 'DESCRIPCION',
                  bold: true,
                  fontSize: fS
               },
               { text: ' ', fontSize: fS },
               {
                  text: 'PRECIO',
                  fontSize: fS,
                  bold: true,
                  margin: [0, 0, 35, 0],
                  alignment: 'right'
               }
            ])

            this.detallePagoArancel.forEach((arancel) => {
               result.push([
                  {
                     text: arancel.codigo,
                     alignment: 'right',
                     fontSize: fS
                  },
                  {
                     text: arancel.itemCantidad,
                     alignment: 'right',
                     fontSize: fS
                  },
                  {
                     text:
                        arancel.descripcion +
                        ' ' +
                        (arancel.materiaCodigo ? arancel.materiaCodigo : '') +
                        (this.idiomaProgramaDesc != null
                           ? `, ${this.idiomaProgramaDesc}, NIVEL ${this.idiomaNivel}`
                           : ''),
                     fontSize: fS
                  },
                  { text: '$', fontSize: fS },
                  {
                     text: this.toFixedRegex(Number(arancel.precioUnitario), 2),
                     fontSize: fS,
                     margin: [0, 0, 35, 0],
                     alignment: 'right'
                  }
               ])
            })

            if (this.recargoIdiomas !== undefined) {
               if (this.recargoIdiomas > 0) {
                  result.push([
                     {},
                     {},
                     {
                        text: 'Recargo por pago extemporáneo'.toUpperCase(),
                        alignment: 'left',
                        fontSize: fS
                     },
                     { text: '$', fontSize: 10 },
                     {
                        text: this.recargoIdiomas,
                        alignment: 'left',
                        fontSize: fS
                     }
                  ])
               }
            }

            result.push([
               {
                  text: 'TOTAL A PAGAR ',
                  fontSize: 10,
                  margin: [0, 0, 15, 0],
                  bold: true,
                  alignment: 'right',
                  colSpan: 3
               },
               {},
               {},
               {
                  text: '$',
                  fontSize: 10,
                  bold: true
               },
               {
                  text: this.numFormatIntl(this.totalPagar),
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0, 35, 0],
                  alignment: 'right'
               }
            ])
            return result
         }

         const getDetalleCoutas = () => {
            var result = []
            var fS = this.detallesComprobantes.length < 4 ? 8 : 7
            this.detallesPendientes.forEach((cuota) => {
               if (this.detallesComprobantes.includes(cuota.npe)) {
                  result.push([
                     {
                        text: `CUOTA ${cuota.cuota}`,
                        alignment: 'right',
                        fontSize: fS
                     },
                     {
                        text: `CICLO ${cuota.periodoLectivo} ${
                           cuota.tipoBeca == null
                              ? ''
                              : `CON BECA ${Number(cuota.descuentoPorBeca)}%`
                        }`,
                        fontSize: fS
                     },
                     { text: '$', fontSize: fS },
                     {
                        text:
                           cuota.tipoBeca == null
                              ? this.toFixedRegex(
                                   Number(cuota.monto) + Number(cuota.recargo),
                                   2
                                )
                              : this.toFixedRegex(
                                   Number(cuota.montoConDescuento) +
                                      Number(cuota.recargo),
                                   2
                                ),
                        fontSize: fS,
                        margin: [0, 0, 35, 0],
                        alignment: 'right'
                     }
                  ])
               }
            })

            result.push([
               {
                  text: 'TOTAL A PAGAR',
                  fontSize: 10,
                  margin: [0, 0, 15, 0],
                  bold: true,
                  alignment: 'right',
                  colSpan: 2
               },
               {},
               {
                  text: '$',
                  fontSize: 10,
                  bold: true
               },
               {
                  text: this.numFormatIntl(this.totalPagar),
                  fontSize: 10,
                  bold: true,
                  margin: [0, 0, 35, 0],
                  alignment: 'right'
               }
            ])
            return result
         }

         const getCuotasNpes = () => {
            return this.detallesComprobantes.join('\n')
         }

         var dd = {
            pageSize: {
               width: 306.0,
               height: pageHeight
            },
            background: () => {
               return {
                  image: this.selloCanceladoNoDate,
                  absolutePosition: {
                     x: 72,
                     y: pageHeight - 116
                  },
                  width: 170,
                  opacity: 0.3
               }
            },
            watermark: {
               text: 'CANCELADO',
               color: 'red',
               angle: -35,
               fontSize: 40,
               opacity: 0.3,
               bold: true
            },
            pageMargins: [20, 20],
            // Pie de pagina con numero de páginas
            footer: (currentPage, pageCount) => {
               return {
                  margin: [20, 0],
                  fontSize: 10,
                  alignment: 'right',
                  text: `Página ${currentPage.toString()} de ${pageCount}`
               }
            },
            content: [
               {
                  table: {
                     heights: 390.0,
                     widths: ['*'],
                     body: [
                        [
                           {
                              table: {
                                 widths: [60, '*', '*'],
                                 body: [
                                    [
                                       {
                                          text: 'UNIVERSIDAD CATÓLICA\nDE EL SALVADOR',
                                          font: 'TimesNewRoman',
                                          fontSize: 10,
                                          bold: true,
                                          alignment: 'center',
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    [
                                       'CARNET:',
                                       {
                                          text: this.carnet,
                                          colSpan: 2
                                       },
                                       {}
                                    ],
                                    [
                                       'ALUMNO:',
                                       {
                                          text: this.alumno,
                                          colSpan: 2
                                       },
                                       {}
                                    ],
                                    [
                                       'CARRERA:',
                                       {
                                          text: this.nombreCarrera,
                                          colSpan: 2
                                       },
                                       {}
                                    ],
                                    [
                                      {
   text:
   (() => {
      const carrera = this.cmbCarrera.find(
         obj => obj.codigo == this.selectCarrera
      )

      const nombre = (carrera?.nombre || '')
         .trim()
         .toUpperCase()

      const esPosgrado = this.listaPosgrados.has(nombre)

      return esPosgrado
         ? 'ESCUELA DE POSGRADOS'
         : 'FACULTAD:\n' + (carrera?.unidadAcademica || '')
   })(),
bold: true,
alignment: 'center',
colSpan: 3

},

                                       {},
                                       {}
                                    ],
                                    [
                                       {
                                          text: '_',
                                          color: 'white',
                                          fontSize: 6,
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    [
                                       {
                                          text:
                                             'MANDAMIENTO DE PAGO DE ' +
                                             (tipo == 'arancel'
                                                ? 'ARANCELES'
                                                : 'CUOTAS'),
                                          bold: true,
                                          fontSize: 10,
                                          alignment: 'center',
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    [
                                       {
                                          table: {
                                             widths:
                                                tipo == 'arancel'
                                                   ? [35, 25, 120, 5, '*']
                                                   : [60, 120, 5, '*'],
                                             body:
                                                tipo == 'arancel'
                                                   ? getDetalleAranceles()
                                                   : getDetalleCoutas()
                                          },
                                          layout: 'noBorders',
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    [
                                       {
                                          text: [
                                             {
                                                text:
                                                   this.materiaCodigo != '' &&
                                                   this.materiaNombre != ''
                                                      ? this.materiaCodigo +
                                                        ': '
                                                      : '',
                                                bold: true
                                             },
                                             this.materiaCodigo != '' &&
                                             this.materiaNombre != ''
                                                ? this.materiaNombre
                                                : ''
                                          ],
                                          fontSize:
                                             this.materiaCodigo != '' &&
                                             this.materiaNombre != ''
                                                ? 8
                                                : 1,
                                          align: 'justify',
                                          margin: [20, 0],
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    [
                                       {
                                          text: '_',
                                          color: 'white',
                                          fontSize: 3,
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    [
                                       {
                                          text: tipo == 'arancel' ? '' : 'NPE',
                                          fontSize: tipo == 'arancel' ? 1 : 9,
                                          bold: true,
                                          alignment: 'right'
                                       },
                                       {
                                          text:
                                             tipo == 'arancel'
                                                ? this.npe
                                                : getCuotasNpes(),
                                          fontSize: 8,
                                          bold: true,
                                          colSpan: 2
                                       },
                                       {}
                                    ],
                                    [
                                       {
                                          text: 'Referencia',
                                          fontSize: 9,
                                          bold: true,
                                          alignment: 'right'
                                       },
                                       {
                                          text: this.referencia,
                                          fontSize: 9,
                                          bold: true,
                                          colSpan: 2
                                       },
                                       {}
                                    ],
                                    [
                                       {
                                          text: 'Autorización',
                                          fontSize: 9,
                                          bold: true,
                                          alignment: 'right'
                                       },
                                       {
                                          text: this.autorizacion,
                                          fontSize: 9,
                                          bold: true,
                                          colSpan: 2
                                       },
                                       {}
                                    ],
                                    [
                                       {
                                          text: 'Fecha de pago',
                                          fontSize: 9,
                                          bold: true,
                                          alignment: 'right'
                                       },
                                       {
                                          text: this.fechaDePago,
                                          fontSize: 9,
                                          bold: true,
                                          colSpan: 2
                                       },
                                       {}
                                    ],
                                    [
                                       {
                                          text: 'COMPROBANTE ALUMNO',
                                          bold: true,
                                          alignment: 'center',
                                          colSpan: 3
                                       },
                                       {},
                                       {}
                                    ],
                                    [
                                       {
                                          text: 'El presente mandamiento, no sustituye facturas o comprobantes de crédito fiscal.',
                                          bold: true,
                                          alignment: 'center',
                                          colSpan: 3,
                                          margin: [20, 5]
                                       },
                                       {},
                                       {}
                                    ]
                                 ]
                              },
                              margin: [0, 0, 15, 0],
                              layout: 'noBorders'
                           }
                        ]
                     ]
                  },
                  layout: 'noBorders'
               }
            ],
            defaultStyle: {
               fontSize: 9
            }
         }

         var fechaFile = this.fechaDePago.includes('/')
            ? this.parseDate(this.fechaDePago.substr(0, 10))
            : this.fechaDePago.substr(0, 10)

         var filename =
            'Comprobante ' +
            this.autorizacion +
            ' Colecturia Digital ' +
            fechaFile +
            '.pdf'
         getReporteLib().then((res) => res.generarPDF(mode, dd, filename))
      },
      actualizarEstadoCuenta() {
         this.listarCuotasPendientes()
         this.actualizarCooldown = true
         this.actualizarSegundos = 10
         const intervalo = setInterval(() => {
            this.actualizarSegundos--
            if (this.actualizarSegundos <= 0) {
               clearInterval(intervalo)
               this.actualizarCooldown = false
            }
         }, 1000)
      },
      // Listar cuotas del pharo que aun no esten facturadas
      listarCuotasPendientes() {
         this.poseeBecaActiva = false
         this.detallesPendientes = []
         this.ciclosBecasPendientes = []
         this.loadingCuotas = true
         const t0Cuotas = performance.now()
         axios
            .get(
               `api/Contrato/Cuotas?Carnet=${this.carnet}&IncluirDeuda=true&Actual=true`
            )
            .then((response) => {
               const msTotal = Math.round(performance.now() - t0Cuotas)
               const msBackend = response.headers['x-timing'] || 'n/d'
               console.info(`[PERF] GetCuotas | Frontend total: ${msTotal}ms | Backend: ${msBackend}`)
               this.detallesPendientes = response.data
            })
            .catch(() => {
               //console.log(error)
            })
            .finally(() => {
               this.loadingCuotas = false
               // Obteniendo disctinc de ciclos con cuotas pendientes
               this.detallesPendientes.forEach((cuota) => {
                  if (
                     !this.ciclosBecasPendientes.includes(
                        cuota.periodoLectivo
                     ) &&
                     cuota.tipoBeca != null
                  ) {
                     this.ciclosBecasPendientes.push(cuota.periodoLectivo)
                  }
               })

               // Verficiar info de ciclos con becas
               this.countBeca = 0
               this.verificarInfoBeca()
            })
      },
      // Obtener informacion del alumno
      getInfoAlumno() {
         //console.log(me.carnet)
         axios
            .get('api/FormularioPlanPago/AlumnoInfo?carnet=' + this.carnet)
            .then((response) => {
               this.alumnoInfo = response.data[0]
               this.alumno =
                  this.alumnoInfo.primerNombre +
                  ' ' +
                  this.alumnoInfo.segundoNombre +
                  ' ' +
                  this.alumnoInfo.primerApellido +
                  ' ' +
                  this.alumnoInfo.segundoApellido +
                  ' ' +
                  this.alumnoInfo.tercerApellido

               this.nombres =
                  this.alumnoInfo.primerNombre +
                  ' ' +
                  this.alumnoInfo.segundoNombre
               this.apellidos =
                  this.alumnoInfo.primerApellido +
                  ' ' +
                  this.alumnoInfo.segundoApellido +
                  ' ' +
                  this.alumnoInfo.tercerApellido

this.codigoCarreraOriginal = this.alumnoInfo.carreraCodigo
        .toString()
        .trim()

               this.selectCarrera = this.alumnoInfo.carreraCodigo
               if (
                  this.alumnoInfo.carreraCodigo.toString().trim().length == 4
               ) {
                  this.selectCarrera = this.alumnoInfo.carreraCodigo
                     .toString()
                     .trim()
                     .substr(1, 3)
               } else {
                  this.selectCarrera = this.alumnoInfo.carreraCodigo
                     .toString()
                     .trim()
               }
            })
            .catch(() => {
               //console.log(error)
            })
            .finally(() => {
               this.alumno = this.alumno.replace(/  +/g, ' ')
            })
      },
      // Listar comboboxes
      listarComboboxes() {
         axios
            .get('api/general/CarreraUniversitaria')
            .then((response) => {
               this.cmbCarrera = response.data
            })
            .catch(() => {
               //console.log(error)
            })
            .finally(() => {
               this.getInfoAlumno()
            })
         axios
            .get('api/Arancel/publicos?EsPublico=false&carnet=' + this.carnet)
            .then((response) => {
               this.cmbArancel = response.data.sort(this.dynamicSort('nombre'))
            })
            .catch(() => {
               //console.log(error)
            })
      },
      // Cerrar ventana de dialogo
      close() {
         this.dialogDemoTalonario = false
         this.clear()
         setTimeout(() => {
            this.editedIndex = -1
         }, 300)
      },
      // Limpiar formularios y componentes
      clear() {
         this.talonario = []
         this.contratoId = ''
         this.editedIndex = -1
         this.configuracionPago = ''
         this.unidadEducativa = ''
         this.numeroTalonario = ''
         this.selectSede = ''
         this.selectEstadoTalonario = ''
         this.selectProgramaArancel = null
         this.carnet = ''
         this.alumno = ''
         this.ntalonario = ''
         this.cicloNombre = ''
      },
      // Get base64 image
      toDataURL(url) {
         return new Promise(function (resolve) {
            var xhr = new XMLHttpRequest()
            xhr.onload = function () {
               var reader = new FileReader()
               reader.onloadend = function () {
                  resolve(reader.result)
               }
               reader.readAsDataURL(xhr.response)
            }
            xhr.open('GET', url)
            xhr.responseType = 'blob'
            xhr.send()
         })
      },
      // Mostrar el dialog de pago de cuota
      showPagoCuota(item) {
         this.npes = []
         this.idTransaccion = ''
         this.numeroCuota = item.cuota
         this.recargo = item.recargo
         this.cuotaDescuento = item.descuentoPorBeca
         this.cuotaTipoBeca = item.tipoBeca
         this.npes.push({ npe: item.npe })
         this.periodoLectivo = item.periodoLectivo
         this.totalPagar =
            item.tipoBeca == null
               ? this.numFormatIntl(Number(item.monto) + Number(item.recargo))
               : this.numFormatIntl(
                    Number(item.montoConDescuento) + Number(item.recargo)
                 )

         this.totalSinDescuento = this.numFormatIntl(
            Number(item.monto) + Number(item.recargo)
         )
         this.totalConDescuento = item.montoConDescuento
         this.contratoId = item.contratoId
         // Obteniendo info de talonario
         this.getInfoTalonario().then(() => {
            this.dialogPagoCuota = true
         })
         if (document.activeElement instanceof HTMLElement)
            document.activeElement.blur()
      },
      // Cerrar el dialog de pago de cuota
      closePagoCuota() {
         this.cuotaDescuento = 0
         this.totalConDescuento = 0
         this.totalSinDescuento = 0
         this.cuotaTipoBeca = null
         this.numeroCuota = ''
         this.recargo = 0
         this.periodoLectivo = ''
         this.idTransaccion = ''
         this.totalPagar = ''
         this.talonario = []
         this.aranceles = []
         this.npes = []
         this.dialogPagoCuota = false
      },
      // Mostrar el dialog de pago de cuota multiple
      showPagoCuotaMultiple() {
         this.totalPagar = 0
         this.npes = []

         // Por cada cuota seleccionada armar un detalle de pago
         this.cuotasSeleccionadas.forEach((cuota) => {
            // Acumulando total a pagar
            this.totalPagar =
               cuota.tipoBeca == null
                  ? this.totalPagar +
                    Number(cuota.monto) +
                    Number(cuota.recargo)
                  : this.totalPagar +
                    Number(cuota.montoConDescuento) +
                    Number(cuota.recargo)

            // Preparando arreglo de npes a enviar en transaccion
            this.npes.push({ npe: cuota.npe })

            // Creando detalle de pago
            this.cuotasPagoMultiple.push({
               descripcion:
                  'Cuota # ' +
                  cuota.cuota +
                  ' - Ciclo: ' +
                  cuota.periodoLectivo,
               precioUnitario:
                  cuota.tipoBeca == null
                     ? Number(cuota.monto) + Number(cuota.recargo)
                     : Number(cuota.montoConDescuento) + Number(cuota.recargo)
            })
         })

         this.dialogPagoCuotaMultiple = true
      },
      // Cerrar el dialog de pago de cuota multiple
      closePagoCuotaMultiple() {
         this.idTransaccion = ''
         this.totalPagar = ''
         this.npes = []
         this.cuotasPagoMultiple = []
         this.dialogPagoCuotaMultiple = false
      },
      // Mostrar el dialog de pago de arancel
      showPagoArancel(item) {
         if (this.$refs.formPagoProgramaArancel.validate()) {
            this.totalPagar = item.precio
            this.itemCodigo = item.codigo
            this.arancelCantidad = item.porCantidad
            this.arancelDescripcion = item.descripcion
            this.detallePagoArancel = []
            this.itemCantidad = 1
            this.itemPrecio = Number(item.precio)

            // Crear arreglo de detalle de pago arancel
            var extra =
               item.codigoMateria === undefined ? '' : ' ' + item.codigoMateria

            if (item.codigo == '01-019' || item.codigo == '01-023') {
               item.nombre = item.materia
            }

            this.detallePagoArancel.push({
               codigo: item.codigo,
               descripcion: item.nombre + extra,
               precioUnitario: item.precio
            })

            // Preparar variables a enviar en post
            this.arancelCodigo = item.codigo
            this.seccion = item.seccion === undefined ? '' : item.seccion
            this.periodoDeCiclo =
               item.periodoDeCiclo === undefined ? 0 : item.periodoDeCiclo
            this.decanatoCodigo =
               item.codigoDecanato === undefined ? '' : item.codigoDecanato
            this.materiaCodigo =
               item.codigoMateria === undefined ? '' : item.codigoMateria
            this.materiaNombre = item.materia === undefined ? '' : item.materia

            // Mostrar dialog de detalles de pago
            this.dialogPagoArancel = true
         }
         if (document.activeElement instanceof HTMLElement)
            document.activeElement.blur()
      },
      // Mostrar el dialog de pago de idiomas
      showPagoIdioma(item) {
         this.listarProgramas(item.idioma == 'EN' ? 2 : 6)
         this.idiomaVencido = item.vencido
         this.idiomaMesesDesdeUltimoModulo = item.mesesDesdeUltimoModulo
         this.idiomaLimiteMesesInacividad = item.limiteMesesInactividad
         this.idiomaNivel = item.ultimoNivelAprobado
         this.idiomaMonto = item.monto
         this.idiomaProgramaId = ''
         this.idiomaCodigoAlumno = item.codigoIdiomas
         this.idiomaCuota = item.cuota
         this.idiomaProgramaDesc = item.programaDescripcion
         this.idiomaProgramaCodigo = item.programaCodigo
         this.idiomaNombre =
            item.idioma == 'EN'
               ? 'Inglés'
               : item.idioma == 'FR'
               ? 'Francés'
               : item.idioma
         //this.totalPagar = this.idiomaMonto
         this.dialogPagoIdioma = true

         axios
            .get('/api/pagosIdiomas/recargo')
            .then((response) => {
               this.recargoIdiomas = response.data.recargo
            })
            .catch((error) => {
               console.log('error:' + error.response)
            })
         if (document.activeElement instanceof HTMLElement)
            document.activeElement.blur()
      },
      closePagoIdioma() {
         this.selectPrograma = ''
         this.idiomaVencido = false
         this.idiomaMesesDesdeUltimoModulo = 0
         this.idiomaLimiteMesesInacividad = 0
         this.nivelDeshabilitado = false
         this.cupoAgotado = false
         this.disablePagoIdioma = false
         this.idiomaProgramaDesc = ''
         this.idiomaNivel = ''
         this.idiomaMonto = ''
         this.idiomaProgramaId = ''
         this.idiomaNombre = ''
         this.$refs.formPagoIdioma.reset()
         this.dialogPagoIdioma = false
         this.totalPagar = ''
      },
      // Cerrar el dialog de pago de arancel
      closePagoArancel() {
         this.arancelCodigo = ''
         this.seccion = ''
         this.periodoDeCiclo = ''
         this.arancelCantidad = false
         this.arancelDescripcion = ''
         this.decanatoCodigo = ''
         this.materiaCodigo = ''
         this.detallePagoArancel = []
         this.idTransaccion = ''
         this.totalPagar = ''
         this.itemCantidad = 1
         this.itemPrecio = ''
         this.itemCodigo = ''
         this.dialogPagoArancel = false
      },
      // Obtener informacion del talonario de la cuota seleccionada
      getInfoTalonario() {
         return new Promise((resolve) => {
            const cacheKey = this.carnet + '_' + this.periodoLectivo
            if (this.talonarioCache[cacheKey]) {
               this.talonario = this.talonarioCache[cacheKey].talonario
               this.aranceles = this.talonarioCache[cacheKey].aranceles
               resolve('ok')
               return
            }
            axios
               .get(
                  'api/Contrato?Carnet=' +
                     this.carnet +
                     '&Ciclo=' +
                     this.periodoLectivo
               )
               .then((response) => {
                  this.talonario = response.data[0]
                  this.totalConDescuento = 0
                  this.aranceles = []
                  this.talonario.detalleContrato.forEach((el) => {
                     //console.log(el)
                     this.aranceles.push({
                        articulo: el.articulo,
                        aplicaBeca: el.aplicaBeca,
                        descripcion: el.descripcion,
                        tipoCobro: el.tipoCobro,
                        precioUnitario:
                           el.aplicaBeca && this.cuotaTipoBeca != null
                              ? Number(el.precioUnitario) -
                                Number(el.precioUnitario) *
                                   (Number(this.cuotaDescuento) / 100)
                              : el.precioUnitario,
                        montoImpuesto: el.montoImpuesto,
                        extraordinaria: el.extraordinaria,
                        procesoGraduacion: el.procesoGraduacion,
                        contratoId: el.contratoId
                     })
                     this.totalConDescuento =
                        Number(el.totalConDescuento) +
                        (el.aplicaBeca && this.cuotaTipoBeca != null
                           ? Number(el.precioUnitario) *
                             (Number(this.cuotaDescuento) / 100)
                           : el.precioUnitario)
                  })
               })
               .catch(() => {
                  //console.log(error)
               })
               .finally(() => {
                  this.talonarioCache[cacheKey] = { talonario: this.talonario, aranceles: this.aranceles }
                  resolve('ok')
               })
         })
      },
      // Selector de color de chips de estado en datatable
      getColorEstado(item) {
         if (
            this.toISOLocal(new Date()).substr(0, 10) >
               this.parseDate(item.fechaVencimiento) &&
            !item.facturado
         ) {
            return 'red'
         } else {
            if (item.facturado) {
               return 'green'
            } else {
               return 'blue'
            }
         }
      },
      // Selector de estados en datatable
      getStatus(item) {
         if (
            this.toISOLocal(new Date()).substr(0, 10) >
            this.parseDate(item.fechaVencimiento)
         ) {
            return 'En mora'
         } else {
            return 'Pendiente'
         }
      },
      // Listar aranceles en datatable
      listarAranceles() {
         var today = this.toISOLocal(new Date()).substr(0, 10)

         this.detallesAranceles = []
         if (this.selectArancel == this.EXAMEN_COMPLEMENTARIO) {
            // SI PIDE COMPLEMENTARIOS
            this.headersAraFiltered = this.headersAraComple
            axios
               .get(
                  'api/Alumno/Complementario?Carnet=' +
                     this.carnet +
                     '&Year=' +
                     today.substr(0, 4) +
                     '&Ciclo=' +
                     (today <= today.substr(0, 4) + '-07-31' ? 1 : 2)
               )
               .then((response) => {
                  var temp = response.data
                  temp.forEach((el) => {
                     el.precio = this.getPrecio()
                     el.descripcion = this.getDesc()
                     el.codigo = this.selectArancel
                     el.facturado = false
                     el.fechaDePago = null
                  })
                  this.detallesAranceles = temp
               })
               .catch(() => {
                  //console.log(error)
               })
               .finally(() => {
                  this.loadingAranceles = false
               })
         } else if (this.selectArancel == this.EXAMEN_DIFERIDO) {
            // SI PIDE DIFERIDOS
            this.headersAraFiltered = this.headersAraDife
            axios
               .get(
                  'api/Alumno/Diferido?Carnet=' +
                     this.carnet +
                     '&Year=' +
                     today.substr(0, 4) +
                     '&Ciclo=' +
                     (today <= today.substr(0, 4) + '-07-31' ? 1 : 2) +
                     '&Periodo=' +
                     this.periodoDiferidos
               )
               .then((response) => {
                  var temp = response.data
                  temp.forEach((el) => {
                     el.precio = this.getPrecio()
                     el.descripcion = this.getDesc()
                     el.codigo = this.selectArancel
                     el.facturado = false
                  })
                  this.detallesAranceles = temp
               })
               .catch(() => {
                  //console.log(error)
               })
               .finally(() => {
                  this.loadingAranceles = false
               })
         } else if (
            this.selectArancel == this.EQUIVALENCIA_INTERNA ||
            this.selectArancel == this.EQUIVALENCIA_EXTERNA
         ) {
            axios
               .get(`/api/Pago/VerificarEquivalencias?carnet=${this.carnet}`)
               .then((res) => {
                  this.totalEquivalencias = 0
                  this.equivalenciasPendientes = false

                  this.totalEquivalencias = res.data.equivalenciasPendientes

                  if (this.totalEquivalencias > 0) {
                     this.equivalenciasPendientes = true

                     this.headersAraFiltered = this.headersAra
                     this.detallesAranceles = []
                     this.detallesAranceles.push(
                        this.cmbArancel.find(
                           (obj) => obj.codigo == this.selectArancel
                        )
                     )
                  } else {
                     this.showSnack(
                        'No cuenta con equivalencias pendientes...',
                        'snackError'
                     )
                  }
               })
               .catch((err) => console.error(err))
               .finally(() => (this.loadingAranceles = false))
         } else {
            // SI ES CUALQUIER OTRO ARANCEL BUSCAR EN ARREGLO OBTENIDO
            this.headersAraFiltered = this.headersAra
            this.detallesAranceles = []
            this.detallesAranceles.push(
               this.cmbArancel.find((obj) => obj.codigo == this.selectArancel)
            )
            this.loadingAranceles = false
         }
      },
      getDesc() {
         let desc
         for (let i = 0; i < this.cmbArancel.length; i++) {
            if (this.selectArancel == this.cmbArancel[i].codigo) {
               desc = this.cmbArancel[i].nombre
               return desc
            }
         }
      },
      getPrecio() {
         let precio
         for (let i = 0; i < this.cmbArancel.length; i++) {
            if (this.selectArancel == this.cmbArancel[i].codigo) {
               precio = this.cmbArancel[i].precio
               return precio
            }
         }
      },
      getRecargoIdiomas(programaIdiomasId) {
         axios
            .get('/api/pagosIdiomas/recargo?programaId=' + programaIdiomasId)
            .then((response) => {
               this.recargoIdiomas = response.data.recargo
               this.totalPagar =
                  parseFloat(this.idiomaMonto) + parseFloat(this.recargoIdiomas)
            })
            .catch((error) => {
               console.log('error:' + error.response)
            })
      }
   }
}
</script>
